// 2022/12新增
// 過敏史
// 用藥史
// 家族病史

import { format } from 'date-fns';
import React, { useRef } from 'react';
// import './App.css';
// import Signature from './Signature';
import TextField from '@material-ui/core/TextField';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import GridContainer from "../components/Grid/GridContainer";
import GridItem from "../components/Grid/GridItem";
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import _, { omit, pick, round, slice } from 'lodash';
import InputAdornment from "@material-ui/core/InputAdornment";
import { FormControl, FormLabel, FormHelperText, Paper, MenuItem, useForkRef, Select, InputLabel, IconButton, Grid } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker, DatePicker, KeyboardDateTimePicker, KeyboardTimePicker } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import TodayIcon from "@material-ui/icons/UpdateOutlined";
import moment from "moment";
import Typography from '@material-ui/core/Typography';
// import { PDFDownloadLink, Document, Page,PDFViewer } from '@react-pdf/renderer'
// import axios from "axios";
import Qs from "qs";
import JSEncrypt from 'jsencrypt';
// import jsPDF from 'jspdf';
// import html2canvas from "html2canvas";
import { actions } from "../reducers/app";
import { useDispatch, useSelector } from "react-redux";
import PF from "../_Services/publicFunction";
import LinearProgress from '@material-ui/core/LinearProgress';
import useSound from 'use-sound';
import clickdown from '../sounds/clickdown.wav';
import clickup from '../sounds/clickdown.wav';
import { useReactToPrint } from 'react-to-print';
import ReactToPrint from 'react-to-print';
import Questionaire67th from './67th';
import { props } from 'ramda';
import { injectIntl, intlShape, useIntl, FormattedMessage } from 'react-intl';
import { useSnackbar } from "notistack";
import CancelIcon from '@material-ui/icons/Cancel';
import DateFnsUtils from "@date-io/date-fns";

// import { ComponentToPrint } from './ComponentToPrint';

// var domToPdf = require('dom-to-pdf');
// const domToImage = require('dom-to-image');

// var instance = axios.create({
//   // timeout: 1000,   //暫不設置timeout
//   async: true,
//   crossDomain: true,
//   headers: {
//     "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
//     "X-Requested-With": "XMLHttpRequest", //for MVC Request.IsAjaxRequest()
//   }
// });

const PUBLIC_KEY_PEM = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA6SX2hSoE+0PE064cjmOE
yl5e+iBNykScwjZ/7SN/Mt0ssJBpwLw7/a7msKc7IH4QRnaWNRu/V7wUtc46HuDO
fSM2zGqd+SDvMGevbjwExNRtsqpUeYd95fkkg1BeEC/mthjIOJQK5xRoFYAN0vze
D8THTjwIB2+JmWOuHG9bqv2VnM2/jkJa9OblyZ58H+hSdfE2ZMKDYon3YQsK8UEM
b8zcjwiTO8L5aUjy98mc+4eKkizb5E05phusaSK2FXG/ER3z6wFEZQe5hrIWnGtY
mF3JfqQo0KweMuBSsInazJxbCIySBuyug07ceI7RMXSIATMEt/mf//dEIDwliemc
aQIDAQAB
-----END PUBLIC KEY-----
`;

function encryptRSA(text) {
  const enc = new JSEncrypt();
  enc.setPublicKey(PUBLIC_KEY_PEM);
  const out = enc.encrypt(text); // Base64
  if (!out) throw new Error('RSA encrypt failed');
  return out;
}

const ref = React.createRef();
const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 8,
    // borderRadius: 5,
  },
  colorPrimary: {
    //backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
  },
  bar: {
    // borderRadius: 5,
    backgroundColor: '#1a90ff',
  },
}))(LinearProgress);


const Questionaire80th = React.forwardRef((props, ref) => {
  //   const { tabList } = useSelector(state => ({
  //     tabList: state.app.tabList,
  //   }));
  const intl = useIntl();

  const [numerator, setNumerator] = React.useState(0);
  const [denominator, setDenominator] = React.useState(17);
  React.useEffect(() => {
    console.log("分子", numerator);
  }, [numerator])
  React.useEffect(() => {
    console.log("分母", denominator);
  }, [denominator])


  const dispatch = useDispatch();

  const { handleNext, setActiveStep } = props;

  const initialRender = React.useRef(true);
  const [imageURL, setImage] = React.useState(null);  //提交=>簽名檔img
  // const [open, setOpen] = React.useState(false);
  const [playActive] = useSound(
    clickdown,
    { volume: 0.25 }
  );
  const [playOn] = useSound(
    clickup,
    { volume: 0.25 }
  );
  const [uploadFormat, setUpload] = React.useState({
    0: { BarCodeStr: "", QuestionNo: 80, Category: "作業經歷", titleNo: 1, Title: "", SelectTitle: "曾經從事＿，起始日期：＿年＿月，截止日期：＿年＿月，共＿年＿月", Answer: "", Other: "" },
    1: { BarCodeStr: "", QuestionNo: 80, Category: "作業經歷", titleNo: 2, Title: "", SelectTitle: "目前從事＿，起始日期：＿年＿月，截止日期：＿年＿月，共＿年＿月，是否需輪班　□是（□兩班制　□三班制　□四班制　□其他：＿）　□否", Answer: "", Other: "" },
    2: { BarCodeStr: "", QuestionNo: 80, Category: "作業經歷", titleNo: 3, Title: "", SelectTitle: "過去1個月，平均每週工時為：＿小時(請以檢查日前1個月填寫)；過去6個月，平均每週工時為：＿小時(請以檢查日前6個月填寫)", Answer: "", Other: "" },
    3: { BarCodeStr: "", QuestionNo: 80, Category: "作業檢查時期", titleNo: 1, Title: "檢查時期（原因）", SelectTitle: "□新進員工（受僱時）　□定期檢查", Answer: "", Other: "" },
    4: { BarCodeStr: "", QuestionNo: 80, Category: "既往病史", titleNo: 1, Title: "您是否曾患有下列慢性疾病：（請在適當項目前打勾）", SelectTitle: "□高血壓　□糖尿病　□心臟病　□癌症＿　□白內障　□中風　□癲癇　□氣喘　□慢性氣管炎、肺氣腫　□肺結核　□腎臟病　□肝病　□貧血　□中耳炎　□聽力障礙　□甲狀腺疾病　□消化性潰瘍、胃炎　□逆流性食道炎 □骨折＿　□手術開刀＿　□其他慢性病＿ □以上皆無", Answer: "", Other: "" },
    5: { BarCodeStr: "", QuestionNo: 80, Category: "生活習慣", titleNo: 1, Title: "請問您過去一個月內是否有吸菸？", SelectTitle: "□從未吸菸　□偶爾吸(不是天天)　□（幾乎）每天吸，平均每天吸＿支，已吸菸＿年　□已經戒菸，戒了＿年＿個月。", Answer: "", Other: "" },
    6: { BarCodeStr: "", QuestionNo: 80, Category: "生活習慣", titleNo: 2, Title: "請問您最近六個月內是否有嚼食檳榔？", SelectTitle: "□從未嚼食檳榔　□偶爾嚼(不是天天)　□(幾乎)每天嚼，平均每天嚼＿顆，已嚼＿年　□已經戒食，戒了＿年＿個月。", Answer: "", Other: "" },
    7: { BarCodeStr: "", QuestionNo: 80, Category: "生活習慣", titleNo: 3, Title: "請問您過去一個月內是否有喝酒？", SelectTitle: "□從未喝酒　□偶爾喝(不是天天)　□（幾乎）每天喝，平均每週喝＿次，最常喝＿酒，每次＿瓶　□已經戒酒，戒了＿年＿個月。", Answer: "", Other: "" },
    8: { BarCodeStr: "", QuestionNo: 80, Category: "生活習慣", titleNo: 4, Title: "請問您於工作日期間", SelectTitle: "平均每天睡眠時間為：＿小時。", Answer: "", Other: "" },
    9: { BarCodeStr: "", QuestionNo: 80, Category: "自覺症狀", titleNo: 1, Title: "您最近三個月是否常有下列症狀：（請在適當項目前打勾）", SelectTitle: "□咳嗽□咳痰□呼吸困難□胸痛□心悸□頭暈□頭痛　□耳鳴　□倦怠　□噁心　□腹痛　□便秘　□腹瀉　□血便　□上背痛　□下背痛　□手腳麻痛　□關節疼痛　□排尿不適　□多尿、頻尿　□手腳肌肉無力　□體重減輕3公斤以上 □其他症狀＿ □以上皆無", Answer: "", Other: "" },
    10: { BarCodeStr: "", QuestionNo: 80, Category: "填表說明", titleNo: 1, Title: "請受檢員工於勞工健檢前，填妥基本資料、作業經歷、檢查時期、既往病史、生活習慣及自覺症狀六大項，再交由醫護人員作確認，以有效篩檢出疾病；若事業單位已提供受檢員工基本資料及作業經歷電子檔給指定醫療機構，可不必請受檢員工重複填寫。", SelectTitle: "", Answer: "", Other: "" },
    11: { BarCodeStr: "", QuestionNo: 80, Category: "填表說明", titleNo: 2, Title: "自覺症狀乙項，請受檢者依自身實際症狀勾選。", SelectTitle: "", Answer: "", Other: "" },
    12: { BarCodeStr: "", QuestionNo: 80, Category: "基本資料", titleNo: 1, Title: "", SelectTitle: "事業單位名稱：＿", Answer: "", Other: "" },
    13: { BarCodeStr: "", QuestionNo: 80, Category: "基本資料", titleNo: 2, Title: "", SelectTitle: "受雇日期：＿", Answer: "", Other: "" },
    14: { BarCodeStr: "", QuestionNo: 80, Category: "過敏史", titleNo: 1, Title: "過敏史：（請在適當項目前打勾）", SelectTitle: "□食物，請填寫＿　□塵蹣，請填寫＿　□化學製劑，請填寫＿　□其他，請填寫＿　□無", Answer: "", Other: "" },
    17: { BarCodeStr: "", QuestionNo: 80, Category: "藥物過敏史", titleNo: 2, Title: "藥物過敏史：（請在適當項目前打勾）", SelectTitle: "□有＿　□無", Answer: "", Other: "" },
    15: { BarCodeStr: "", QuestionNo: 80, Category: "用藥史", titleNo: 1, Title: "用藥史：（請在適當項目前打勾）", SelectTitle: "□糖尿病　□高血壓　□心臟病　□腎臟病　□其他＿□以上皆無", Answer: "", Other: "" },
    16: { BarCodeStr: "", QuestionNo: 80, Category: "家族病史", titleNo: 1, Title: "請問您的父母是否曾患有下列慢性疾病：（請在適當項目前打勾）", SelectTitle: "□高血壓　□糖尿病　□心臟病　□癌症＿　□白內障　□中風　□癲癇　□氣喘　□慢性氣管炎、肺氣腫　□肺結核　□腎臟病　□肝病　□貧血　□中耳炎　□聽力障礙　□甲狀腺疾病　□消化性潰瘍、胃炎　□逆流性食道炎", Answer: "", Other: "" },
  });
  // const dispatch = useDispatch();
  const { UserInfo } = useSelector(state => ({
    UserInfo: state.app.UserInfo,
  }));

  const { Confirme } = useSelector(state => ({
    Confirme: state.app.Confirme,
  }));
  const isShown = Confirme;
  // console.log(isShown)

  //判斷API
  // const questurl = window.location.protocol.slice(0, -1) === 'https' ? "https://mj.mornjoy.com.tw/labourapi/LabourCheck" : "http://mj.mornjoy.com.tw/labourapi/LabourCheck"

  const [formData, setFormData] = React.useState({
    relationship: '',
    name: '',
    phonenum: '',
    otherRelationship: '',
    BloodType: '',
    Occupation: '',
    OwnPhone: '',
    Gender: UserInfo.Sex, // '男' | '女' 依你原本
    LMPDate: null, // Date | null
    IsMenstruating: "", // 新增：目前是否為生理期 是 / 否
    LMPFlags: { Menopause: false, Pregnant: false, PostpartumNoPeriod: false, Other: false },
    LMPOtherText: "",
  });
  React.useEffect(() => {
    PF.instance({
      method: "POST",
      url: PF.url + "/LabourCheck/GetLabourRelation",
      data: Qs.stringify({ Action: "GET", parameter: { id: encryptRSA(UserInfo.PersonalId) } }),
      headers: { token: sessionStorage.token }
    })

      .then(function (response) {
        const { TotalRecord, rows } = response.data;
        // let obj = rows

        if (rows[0]) {
          // console.log(rows[0])
          // console.log(rows)
          console.log(rows[0].relation)
          if (rows[0].relation == '父母' || rows[0].relation == '兄弟姊妹'
            || rows[0].relation == '配偶' || rows[0].relation == '親屬') {
            setFormData(prev => ({
              ...prev,
              relationship: rows[0].relation,
              name: rows[0].name,
              phonenum: rows[0].phonenum,
              BloodType: rows[0].BloodType,
              Occupation: rows[0].Occupation,
              OwnPhone: rows[0].OwnPhone

            }));
          } else {
            setFormData(prev => ({
              ...prev,
              relationship: '其他',
              otherRelationship: rows[0].relation,
              name: rows[0].name,
              phonenum: rows[0].phonenum,
              BloodType: rows[0].BloodType,
              Occupation: rows[0].Occupation,
              OwnPhone: rows[0].OwnPhone
            }));
          }
        }

      })

  }, [])





  const UpdateRelation = () => {
    let X = {
      Action: "GET",
      parameter: {
        BarCodeStr: UserInfo.BarCodeStr,
        id: UserInfo.PersonalId,
        relation: formData.relationship,
        UserName: formData.name,
        phonenum: formData.phonenum,
        BloodType: formData.BloodType,
        Occupation: formData.Occupation,
        OwnPhone: formData.OwnPhone,
        IsMenstruating: formData.IsMenstruating,
        LMPDate: formData.LMPDate ? format(formData.LMPDate, "yyyy/MM/dd") : null,
        LMPStatus: Object.keys(formData.LMPFlags)
          .find((key) => formData.LMPFlags[key]) || "",
        LMPOtherText: formData.LMPOtherText,
      }
    }
    console.log(X)
    if (formData.relationship === '其他') {
      X.parameter.relation = formData.otherRelationship; // 赋值
    }
    PF.instance({
      method: "post",
      url: PF.url + "/LabourCheck/LabourRelationInsert",
      data: Qs.stringify(X),
    })
      .then(function (response) {
        console.log("後端回傳：", response.data);
      });
  }

  const handleChange = (event) => {
    const { name, value } = event.target;

    // 更新狀態
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));

  };


  const Update80th = () => {
    //section 2 到3
    let y = moment(workExp.usedStart.value + '01日', 'YYYY年MM月DD日')
    let z = moment(workExp.usedEnd.value + '01日', 'YYYY年MM月DD日')
    let M = moment(workExp.rightNowStart.value + '01日', 'YYYY年MM月DD日')
    let N = moment(workExp.rightNowEnd.value + '01日', 'YYYY年MM月DD日')

    let HireD = moment(personal.hireDate.value, 'YYYY年MM月DD日')

    let fourth = Object.values(array4th).reduce((a, b) => a + (b.checked ? "||" + b.systemLabel : ""), "");
    let fourthTxt = Object.values(array4thTxtObj).reduce((a, b) => a + ("||" + b.text), "");
    //section 5
    let fiveth_1 = Object.values(array5_1).reduce((a, b) => a + (b.checked ? "||" + b.systemLabel : ""), "");
    let fiveth_1Txt = Object.values(array5thCheck).slice(1, 5).reduce((a, b) => a + "||" + b.value, "")
    let fiveth_2 = Object.values(array5_2).reduce((a, b) => a + (b.checked ? "||" + b.systemLabel : ""), "");
    let fiveth_2Txt = Object.values(array5thCheck).slice(6, 10).reduce((a, b) => a + "||" + b.value, "")
    let fiveth_3 = Object.values(array5_3).reduce((a, b) => a + (b.checked ? "||" + b.systemLabel : ""), "");
    let fiveth_3Txt = Object.values(array5thCheck).slice(11, 16).reduce((a, b) => a + "||" + b.value, "")
    //setction 6
    let Sixth = Object.values(array6th).reduce((a, b) => a + (b.checked ? "||" + b.systemLabel : ""), "");
    //輪班
    let Shift = Object.values(YesShiftChkObj).reduce((a, b) => a + (b.checked ? "||" + b.systemLabel : ""), "");
    // console.log(y.year);
    let Sixth0 = Object.values(array60th).reduce((a, b) => a + (b.checked ? "||" + b.systemLabel : ""), "");
    let Sixth0Txt = Object.values(array60thTxtObj).reduce((a, b) => a + ("||" + b.text), "");
    let Sixth0_drug = Object.values(array60th_drug).reduce((a, b) => a + (b.checked ? "||" + b.systemLabel : ""), "");
    let Sixth0_drugTxt = Object.values(array60th_drugTxtObj).reduce((a, b) => a + ("||" + b.text), "");

    let Seventh = Object.values(array7th).reduce((a, b) => a + (b.checked ? "||" + b.systemLabel : ""), "");
    let SeventhTxt = Object.values(array7thTxtObj).reduce((a, b) => a + ("||" + b.text), "");

    let Eighth = Object.values(array8th).reduce((a, b) => a + (b.checked ? "||" + b.systemLabel : ""), "");
    let EighthTxt = Object.values(array8thTxtObj).reduce((a, b) => a + ("||" + b.text), "");


    // console.log(HireD.year());

    setUpload(prevState => ({
      ...prevState,
      0: { ...prevState[0], BarCodeStr: UserInfo.BarCodeStr, Other: ((workExp.usedJob.value === null || workExp.usedJob.value.length === 0) ? '無' : (forgot ? workExp.usedJob.value + '(忘記日期)' : workExp.usedJob.value)) + "||" + (workExp.usedStart.value === null ? '--' : (y.year() - 1911)) + "||" + (workExp.usedStart.value === null ? '--' : (y.month() + 1)) + "||" + (workExp.usedEnd.value === null ? '--' : (z.year() - 1911)) + "||" + (workExp.usedEnd.value === null ? '--' : (z.month() + 1)) + "||" + (workExp.usedPeriod_Y.value === null ? '--' : workExp.usedPeriod_Y.value) + "||" + (workExp.usedPeriod_M.value === null ? '--' : workExp.usedPeriod_M.value) },
      1: {
        ...prevState[1], BarCodeStr: UserInfo.BarCodeStr, Other: ((workExp.rightNowJob.value === null || workExp.rightNowJob.value.length === 0) ? '無' : workExp.rightNowJob.value) + "||" + (workExp.rightNowJob.value === null ? '--' : (M.year() - 1911)) + "||" + (workExp.rightNowJob.value === null ? '--' : (M.month() + 1)) + "||" + (workExp.rightNowEnd.value === null ? '--' : (N.year() - 1911)) + "||" + (workExp.rightNowEnd.value === null ? '--' : (N.month() + 1)) + "||" + (workExp.rightNowPeriod_Y.value === null ? '--' : workExp.rightNowPeriod_Y.value) + "||" + (workExp.rightNowPeriod_M.value === null ? '--' : workExp.rightNowPeriod_M.value)
          + "||" + (YesShiftChkObj.ShiftOther.value || "")
        , Answer: !shiftChkObj.Yes ? (shiftChkObj.No ? "否" : "") : '是（' + "||" + Shift.substring(2, 999)
      },




      2: { ...prevState[2], BarCodeStr: UserInfo.BarCodeStr, Other: (workExp.workhours_1.value === null ? '--' : workExp.workhours_1.value) + "||" + (workExp.workhours_2.value === null ? '--' : workExp.workhours_2.value) },
      3: { ...prevState[3], BarCodeStr: UserInfo.BarCodeStr, Answer: checked3rd.checkA ? "新進員工（受僱時）　" : "定期檢查" },
      4: { ...prevState[4], BarCodeStr: UserInfo.BarCodeStr, Answer: fourth.substring(2, 999), Other: fourthTxt.substring(2, 999) },
      5: { ...prevState[5], BarCodeStr: UserInfo.BarCodeStr, Answer: fiveth_1.substring(2, 999), Other: fiveth_1Txt.substring(2, 999) },
      6: { ...prevState[6], BarCodeStr: UserInfo.BarCodeStr, Answer: fiveth_2.substring(2, 999), Other: fiveth_2Txt.substring(2, 999) },
      7: { ...prevState[7], BarCodeStr: UserInfo.BarCodeStr, Answer: fiveth_3.substring(2, 999), Other: fiveth_3Txt.substring(2, 999) },
      8: { ...prevState[8], BarCodeStr: UserInfo.BarCodeStr, Other: array5thCheck.sleep.value },
      9: { ...prevState[9], BarCodeStr: UserInfo.BarCodeStr, Answer: Sixth.substring(2, 999), Other: array4thTxtObj.W6.text },
      10: { ...prevState[10], BarCodeStr: UserInfo.BarCodeStr },
      11: { ...prevState[11], BarCodeStr: UserInfo.BarCodeStr, },
      12: { ...prevState[12], BarCodeStr: UserInfo.BarCodeStr, Other: personal.CustName.value },
      13: { ...prevState[13], BarCodeStr: UserInfo.BarCodeStr, Other: (HireD.year() === null || isNaN(HireD.year()) ? '--' : HireD.year() - 1911) + '/' + (HireD.month() === null || isNaN(HireD.month()) ? '--' : HireD.month() + 1) + '/' + (HireD.date() === null || isNaN(HireD.date()) ? '--' : HireD.date()) },
      14: { ...prevState[14], BarCodeStr: UserInfo.BarCodeStr, Answer: Sixth0.substring(2, 999), Other: Sixth0Txt.substring(2, 999) },    //2049
      17: { ...prevState[17], BarCodeStr: UserInfo.BarCodeStr, Answer: Sixth0_drug.substring(2, 999), Other: Sixth0_drugTxt.substring(2, 999) },    //家族過敏史
      15: { ...prevState[15], BarCodeStr: UserInfo.BarCodeStr, Answer: Seventh.substring(2, 999), Other: SeventhTxt.substring(2, 999) },  //2050
      16: { ...prevState[16], BarCodeStr: UserInfo.BarCodeStr, Answer: Eighth.substring(2, 999), Other: EighthTxt.substring(2, 999) },     //2051

    }));

    // console.log("||" + Shift.substring(2, 999));
    // console.log("||" + (YesShiftChkObj.ShiftOther.value || ""));
    // console.log("||" + !shiftChkObj.No ? 'false' : 'true');

    //列印
    // })
    //   var doc = new jsPDF();
    //   //return pdf; //Duke
    // //var doc = new jsPDF(pdf2);
    // //console.log(pdf);
    // //pdf.name = 'test.pdf'

    //var pdf = pdf2.output('blob');
    //pdf.name = 'test.pdf'
    //console.log(pdf);
    // var doc = pdf.output('blob')
    // let data = new FormData();
    // data.append('files', imageURL.getCanvas());
    // //console.log(data);
    // //var doc = btoa(pdf);
    // instance({
    //   method: "post",
    //   url: 'https://localhost:44311' + "/Questionaire/Upload",
    //   data: data,
    // })
    //   .then(function (response) {
    //     console.log(response.data)
    //   })
  }

  React.useEffect(() => {
    if (!initialRender.current) {

      PF.instance({
        method: "post",
        url: PF.url + "/Questionaire/Insert",
        data: Qs.stringify({ list: Object.values(uploadFormat) }),
        headers: { token: sessionStorage.token }
      })
        .then(function (response) {
          // console.log(response.data)
          const { TotalRecord, ErrorMessage } = response.data
          if (TotalRecord <= 0) {
            // alert("問卷提交出錯\r\n" + ErrorMessage + "請致電 04-2255-2555 #168 企業健檢")
            enqueueSnackbar(intl.formatMessage({ id: "update fail" }), { variant: "error", style: { whiteSpace: 'pre-line' } });
          } else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            setImage("Image");
            enqueueSnackbar(intl.formatMessage({ id: "update success" }), { variant: "success", style: { whiteSpace: 'pre-line' } });
          }
        })

    }
  }, [uploadFormat]); //避免循環

  // React.useEffect(() => {
  //   if (initialRender.current) {
  //     initialRender.current = false;
  //   } else {

  //     var element = document.getElementById('signature');
  //     var options = {
  //       filename: uploadFormat[0].BarCodeStr + '.pdf',
  //     };
  //     // var pdf = new jsPDF();

  //     domToImage.toBlob(element).then((blob) => {
  //       // var image = canvas.toDataURL("image/png");
  //       // pdf.addImage(image, 'JPEG', 0, 0);
  //       // document.body.appendChild(image)
  //       // var pdf2 = pdf.output('blob');
  //       let data = new FormData();
  //       data.append('files', blob, uploadFormat[0].BarCodeStr + "-" + new Date().toISOString().split('T')[0] + '.png')
  //       PF.instance({
  //         method: "post",
  //         url: PF.url + "/Questionaire/Upload",
  //         data: data,
  //         headers: { token: sessionStorage.token }
  //       })
  //         .then(function (response) {
  //           // alert("完成")
  //           //console.log(response.data)
  //         })

  //     })
  //   }
  // }, [imageURL]); //避免循環


  //   const handleChange = e => {
  //     if (!_.isNil(imageURL)) {//已提交不得修改

  //     }
  //   }
  //   const [recordObj, setObj] = React.useState({
  //     name: "",
  //     id: ""
  //   });


  const [array4th, setArray4th] = React.useState({
    A4: { name: "A4", label: "高血壓", type: "chkBox", checked: false, gridWid: 3, systemLabel: "高血壓　" }
    , B4: { label: "糖尿病", name: "B4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "糖尿病　" }
    , C4: { label: "心臟病", name: "C4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "心臟病　" }
    , E4: { label: "白內障", name: "E4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "白內障　" }
    , F4: { label: "中風", name: "F4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "中風　" }
    , G4: { label: "癲癇", name: "G4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "癲癇　" }
    , H4: { label: "氣喘", name: "H4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "氣喘　" }
    , I4: { label: "慢性氣管炎、肺氣腫", name: "I4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "慢性氣管炎、肺氣腫　" }
    , J4: { label: "蠶豆症", name: "J4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "蠶豆症　" }
    , K4: { label: "肺結核", name: "K4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "肺結核　" }
    , L4: { label: "腎臟病", name: "L4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "腎臟病　" }
    , M4: { label: "肝病", name: "M4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "肝病　" }
    , N4: { label: "貧血", name: "N4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "貧血　" }
    , O4: { label: "中耳炎", name: "O4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "中耳炎　" }
    , P4: { label: "聽力障礙", name: "P4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "聽力障礙　" }
    , Q4: { label: "甲狀腺疾病", name: "Q4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "甲狀腺疾病　" }
    , R4: { label: "消化性潰瘍、胃炎", name: "R4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "消化性潰瘍、胃炎　" }
    , S4: { label: "逆流性食道炎", name: "S4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "逆流性食道炎" }
    , D4: { label: "癌症", name: "D4", type: "chkBoxTxT", checked: false, gridWid: 6, systemLabel: "癌症" }
    , T4: { label: "骨折", name: "T4", type: "chkBoxTxT", checked: false, gridWid: 6, systemLabel: "骨折" }
    , V4: { label: "手術開刀", name: "V4", type: "chkBoxTxT", checked: false, gridWid: 6, systemLabel: "手術開刀" }
    , U4: { label: "其他慢性病", name: "U4", type: "chkBoxTxT", checked: false, gridWid: 6, systemLabel: "其他慢性病" }
    , allNone: { label: "以上皆無", name: "allNone", type: "chkBox", checked: false, gridWid: 3, systemLabel: "以上皆無" }
  });
  const [array60th, setArray60th] = React.useState({
    U60: { label: "食物，請填寫", name: "U60", type: "chkBoxTxT", checked: false, checked: false, gridWid: 6, systemLabel: "食物" },
    X60: { label: "塵蹣，請填寫", name: "X60", type: "chkBoxTxT", checked: false, checked: false, gridWid: 6, systemLabel: "塵蹣" },
    Y60: { label: "化學製劑，請填寫", name: "Y60", type: "chkBoxTxT", checked: false, checked: false, gridWid: 6, systemLabel: "化學製劑" },
    Z60: { label: "其他，請填寫", name: "Z60", type: "chkBoxTxT", checked: false, checked: false, gridWid: 6, systemLabel: "其他" },
    allNone: { label: "無", name: "allNone", type: "chkBox", checked: false, gridWid: 3, systemLabel: "無" }
  });
  const [array60th_drug, setArray60th_drug] = React.useState({
    U60: { label: "有", name: "U60", type: "chkBoxTxT", checked: false, checked: false, gridWid: 6, systemLabel: "有" },
    allNone: { label: "無", name: "allNone", type: "chkBox", checked: false, gridWid: 3, systemLabel: "無" }
  });
  const [array7th, setArray7th] = React.useState({
    A7: { name: "A7", label: "高血壓", type: "chkBox", checked: false, gridWid: 3, systemLabel: "高血壓　" }
    , B7: { label: "糖尿病", name: "B7", type: "chkBox", checked: false, gridWid: 3, systemLabel: "糖尿病　" }
    , C7: { label: "心臟病", name: "C7", type: "chkBox", checked: false, gridWid: 3, systemLabel: "心臟病　" }
    , E4: { label: "中藥", name: "E4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "中藥　" }
    , F4: { label: "抗憂鬱藥物", name: "F4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "抗憂鬱藥物　" }
    , G4: { label: "抗凝血藥", name: "G4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "抗凝血藥　" }
    // , H4: { label: "氣喘", name: "H4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "氣喘　" }
    // , I4: { label: "慢性氣管炎、肺氣腫", name: "I4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "慢性氣管炎、肺氣腫　" }
    // , J4: { label: "肺氣腫", name: "J4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "肺氣腫　" }
    // , K4: { label: "肺結核", name: "K4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "肺結核　" }
    , L7: { label: "腎臟病", name: "L7", type: "chkBox", checked: false, gridWid: 3, systemLabel: "腎臟病　" }
    // , M4: { label: "肝病", name: "M4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "肝病　" }
    // , N4: { label: "貧血", name: "N4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "貧血　" }
    // , O4: { label: "中耳炎", name: "O4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "中耳炎　" }
    // , P4: { label: "聽力障礙", name: "P4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "聽力障礙　" }
    // , Q4: { label: "甲狀腺疾病", name: "Q4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "甲狀腺疾病　" }
    // , R4: { label: "消化性潰瘍、胃炎", name: "R4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "消化性潰瘍、胃炎　" }
    // , S4: { label: "逆流性食道炎", name: "S4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "逆流性食道炎" }
    // , D4: { label: "癌症", name: "D4", type: "chkBoxTxT", checked: false, gridWid: 6, systemLabel: "癌症" }
    // , T4: { label: "骨折", name: "T4", type: "chkBoxTxT", checked: false, gridWid: 6, systemLabel: "骨折" }
    // , V4: { label: "手術開刀", name: "V4", type: "chkBoxTxT", checked: false, gridWid: 6, systemLabel: "手術開刀" }
    , U7: { label: "其他", name: "U7", type: "chkBoxTxT", checked: false, checked: false, gridWid: 6, systemLabel: "其他" }
    , allNone: { label: "以上皆無", name: "allNone", type: "chkBox", checked: false, gridWid: 3, systemLabel: "以上皆無" }
  });

  const [array8th, setArray8th] = React.useState({
    A8: { name: "A8", label: "高血壓", type: "chkBox", checked: false, gridWid: 3, systemLabel: "高血壓　" }
    , B8: { label: "糖尿病", name: "B8", type: "chkBox", checked: false, gridWid: 3, systemLabel: "糖尿病　" }
    , C8: { label: "心臟病", name: "C8", type: "chkBox", checked: false, gridWid: 3, systemLabel: "心臟病　" }
    , E8: { label: "白內障", name: "E8", type: "chkBox", checked: false, gridWid: 3, systemLabel: "白內障　" }
    , F8: { label: "中風", name: "F8", type: "chkBox", checked: false, gridWid: 3, systemLabel: "中風　" }
    , G8: { label: "癲癇", name: "G8", type: "chkBox", checked: false, gridWid: 3, systemLabel: "癲癇　" }
    , H8: { label: "氣喘", name: "H8", type: "chkBox", checked: false, gridWid: 3, systemLabel: "氣喘　" }
    , I8: { label: "慢性氣管炎、肺氣腫", name: "I8", type: "chkBox", checked: false, gridWid: 3, systemLabel: "慢性氣管炎、肺氣腫　" }
    // , J4: { label: "肺氣腫", name: "J4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "肺氣腫　" }
    , K8: { label: "肺結核", name: "K8", type: "chkBox", checked: false, gridWid: 3, systemLabel: "肺結核　" }
    , L8: { label: "腎臟病", name: "L8", type: "chkBox", checked: false, gridWid: 3, systemLabel: "腎臟病　" }
    , M8: { label: "肝病", name: "M8", type: "chkBox", checked: false, gridWid: 3, systemLabel: "肝病　" }
    , N8: { label: "貧血", name: "N8", type: "chkBox", checked: false, gridWid: 3, systemLabel: "貧血　" }
    , O8: { label: "中耳炎", name: "O8", type: "chkBox", checked: false, gridWid: 3, systemLabel: "中耳炎　" }
    , P8: { label: "聽力障礙", name: "P8", type: "chkBox", checked: false, gridWid: 3, systemLabel: "聽力障礙　" }
    , Q8: { label: "甲狀腺疾病", name: "Q8", type: "chkBox", checked: false, gridWid: 3, systemLabel: "甲狀腺疾病　" }
    , R8: { label: "消化性潰瘍、胃炎", name: "R8", type: "chkBox", checked: false, gridWid: 3, systemLabel: "消化性潰瘍、胃炎　" }
    , S8: { label: "逆流性食道炎", name: "S8", type: "chkBox", checked: false, gridWid: 3, systemLabel: "逆流性食道炎" }
    , D8: { label: "癌症", name: "D8", type: "chkBoxTxT", checked: false, gridWid: 6, systemLabel: "癌症" }
    , T8: { label: "骨折", name: "T8", type: "chkBoxTxT", checked: false, gridWid: 6, systemLabel: "骨折" }
    , V8: { label: "手術開刀", name: "V8", type: "chkBoxTxT", checked: false, gridWid: 6, systemLabel: "手術開刀" }
    , U8: { label: "其他慢性病", name: "U8", type: "chkBoxTxT", checked: false, gridWid: 6, systemLabel: "其他慢性病" }
    , allNone: { label: "以上皆無", name: "allNone", type: "chkBox", checked: false, gridWid: 3, systemLabel: "以上皆無" }
  });


  //既往病史
  const [array4thTxtObj, set4thTxtObj] = React.useState({
    D4: { label: "癌症", name: "D4", type: "chkBoxTxT", checked: false, gridWid: 6, text: "" },
    // N4: { label: "貧血", name: "N4", type: "chkBoxTxT", checked: false, gridWid: 6, text: "" },
    T4: { label: "骨折", name: "T4", type: "chkBoxTxT", checked: false, gridWid: 6, text: "" },
    V4: { label: "手術開刀", name: "V4", type: "chkBoxTxT", checked: false, gridWid: 6, text: "" },
    U4: { label: "其他慢性病", name: "U4", type: "chkBoxTxT", checked: false, checked: false, gridWid: 6, text: "" },
    W6: { label: "其他症狀", name: "W6", type: "chkBoxTxT", checked: false, checked: false, gridWid: 6, text: "" }, //自覺症狀 偷渡紀錄在此
  })
  //過敏史
  const [array60thTxtObj, set60thTxtObj] = React.useState({
    // D4: { label: "癌症", name: "D4", type: "chkBoxTxT", checked: false, gridWid: 6, text: "" },
    // N4: { label: "貧血", name: "N4", type: "chkBoxTxT", checked: false, gridWid: 6, text: "" },
    // T4: { label: "骨折", name: "T4", type: "chkBoxTxT", checked: false, gridWid: 6, text: "" },
    // V4: { label: "手術開刀", name: "V4", type: "chkBoxTxT", checked: false, gridWid: 6, text: "" },
    U60: { label: "食物，請填寫", name: "U60", type: "chkBoxTxT", checked: false, checked: false, gridWid: 6, text: "" },
    X60: { label: "塵蹣，請填寫", name: "X60", type: "chkBoxTxT", checked: false, checked: false, gridWid: 6, text: "" },
    Y60: { label: "化學製劑，請填寫", name: "Y60", type: "chkBoxTxT", checked: false, checked: false, gridWid: 6, text: "" },
    Z60: { label: "其他，請填寫", name: "Z60", type: "chkBoxTxT", checked: false, checked: false, gridWid: 6, text: "" },
    // W6: { label: "其他症狀", name: "W6", type: "chkBoxTxT", checked: false, checked: false, gridWid: 6, text: "" },
  })
  //藥物過敏史
  const [array60th_drugTxtObj, set60th_drugTxtObj] = React.useState({
    // D4: { label: "癌症", name: "D4", type: "chkBoxTxT", checked: false, gridWid: 6, text: "" },
    // N4: { label: "貧血", name: "N4", type: "chkBoxTxT", checked: false, gridWid: 6, text: "" },
    // T4: { label: "骨折", name: "T4", type: "chkBoxTxT", checked: false, gridWid: 6, text: "" },
    // V4: { label: "手術開刀", name: "V4", type: "chkBoxTxT", checked: false, gridWid: 6, text: "" },
    U60: { label: "有", name: "U60", type: "chkBoxTxT", checked: false, checked: false, gridWid: 6, text: "" },
    // W6: { label: "其他症狀", name: "W6", type: "chkBoxTxT", checked: false, checked: false, gridWid: 6, text: "" },
  })
  //用藥史
  const [array7thTxtObj, set7thTxtObj] = React.useState({
    // D4: { label: "癌症", name: "D4", type: "chkBoxTxT", checked: false, gridWid: 6, text: "" },
    // N4: { label: "貧血", name: "N4", type: "chkBoxTxT", checked: false, gridWid: 6, text: "" },
    // T4: { label: "骨折", name: "T4", type: "chkBoxTxT", checked: false, gridWid: 6, text: "" },
    // V4: { label: "手術開刀", name: "V4", type: "chkBoxTxT", checked: false, gridWid: 6, text: "" },
    U7: { label: "其他", name: "U7", type: "chkBoxTxT", checked: false, checked: false, gridWid: 6, text: "" },
    // W6: { label: "其他症狀", name: "W6", type: "chkBoxTxT", checked: false, checked: false, gridWid: 6, text: "" },
  })
  //家族病史
  const [array8thTxtObj, set8thTxtObj] = React.useState({
    D8: { label: "癌症", name: "D8", type: "chkBoxTxT", checked: false, gridWid: 6, text: "" },
    // N4: { label: "貧血", name: "N4", type: "chkBoxTxT", checked: false, gridWid: 6, text: "" },
    T8: { label: "骨折", name: "T8", type: "chkBoxTxT", checked: false, gridWid: 6, text: "" },
    V8: { label: "手術開刀", name: "V8", type: "chkBoxTxT", checked: false, gridWid: 6, text: "" },
    U8: { label: "其他慢性病", name: "U8", type: "chkBoxTxT", checked: false, checked: false, gridWid: 6, text: "" },
  })

  const handleChange4th = e => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, checked } = e.target;
      // console.log(e.target);
      if (name === "allNone") {
        if (array4th.allNone.checked === false) {
          //其他: 不能勾選，除非allnone不勾
          //移除所以勾勾  
          _.forEach(array4th, function (value, key) {
            setArray4th(prevState => ({
              ...prevState,
              [key]: omit(value, ["checked", "error"]),
            }));
          });
          //移除所有文字
          _.forEach(array4thTxtObj, function (value, key) {
            if (key !== "W6") {
              set4thTxtObj(prevState => ({
                ...prevState,
                [key]: { ...value, text: "" }
              }));
            }

          });

          //自己勾上
          setArray4th(prevState => ({
            ...prevState,
            allNone: { ...prevState[name], checked: checked }
          }));
        } else {
          //自己取消，讓其他可以勾
          setArray4th(prevState => ({
            ...prevState,
            allNone: { ...prevState[name], checked: checked }
          }));
        }


      } else {
        //其他:不能勾選，除非allnone不勾
        if (array4th.allNone.checked === false) {
          setArray4th(prevState => ({
            ...prevState,
            [name]: {
              ...array4th[name], checked: checked,
              error: checked === false ? false : (prevState[name].error || false)
            }
          }))
          if (Object.keys(array4thTxtObj).includes(name)) {
            if (name !== "W6") {
              set4thTxtObj(prevState => ({
                ...prevState,
                [name]: {
                  ...prevState[name],
                  checked: checked,  //也要更新 for資料庫導入格式
                  text: checked === false ? "" : (prevState[name].text || "")
                }
              }))
            }

          }
        }
      }
    }
  }
  const handleChangeTxt4th = e => {  //第四區塊文字，抽取出來，改動文字不去觸發calculate_4th
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, value } = e.target;
      set4thTxtObj({
        ...array4thTxtObj,
        [name]: { ...array4thTxtObj[name], text: value }
      })
    }
  }
  //過敏史，打勾部分
  const handleChange60th = e => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, checked } = e.target;
      // console.log(e.target);
      if (name === "allNone") {
        if (array60th.allNone.checked === false) {
          //其他: 不能勾選，除非allnone不勾
          //移除所以勾勾  
          _.forEach(array60th, function (value, key) {
            setArray60th(prevState => ({
              ...prevState,
              [key]: omit(value, ["checked", "error"]),
            }));
          });
          //移除所有文字
          _.forEach(array60thTxtObj, function (value, key) {
            if (key !== "W6") {
              set60thTxtObj(prevState => ({
                ...prevState,
                [key]: { ...value, text: "" }
              }));
            }

          });

          //自己勾上
          setArray60th(prevState => ({
            ...prevState,
            allNone: { ...prevState[name], checked: checked }
          }));
        } else {
          //自己取消，讓其他可以勾
          setArray60th(prevState => ({
            ...prevState,
            allNone: { ...prevState[name], checked: checked }
          }));
        }


      } else {
        setArray60th(prevState => ({
          ...prevState,
          allNone: { ...prevState.allNone, checked: false, error: false },
          [name]: {
            ...prevState[name], checked: checked,
            error: checked === false ? false : (prevState[name].error || false)
          }
        }))
        if (Object.keys(array60thTxtObj).includes(name)) {
          if (name !== "W4") {
            set60thTxtObj(prevState => ({
              ...prevState,
              [name]: {
                ...prevState[name],
                checked: checked,  //也要更新 for資料庫導入格式
                text: checked === false ? "" : (prevState[name].text || "")
              }
            }))
          }

        }
      }
    }
  }
  const handleChangeTxt60th = e => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, value } = e.target;
      set60thTxtObj({
        ...array60thTxtObj,
        [name]: { ...array60thTxtObj[name], text: value }
      })
    }
  }
  //藥物過敏史，打勾部分
  const handleChange60th_drug = (e) => {
    if (!_.isNil(imageURL)) return; // 已提交不得修改

    const { name, checked } = e.target;

    // 先處理 checkbox 狀態
    setArray60th_drug((prev) => {
      // 以 prev 為唯一真相，組出 next
      const next = { ...prev };

      if (name === "allNone") {
        // 點到「全不」
        if (!prev.allNone?.checked && checked) {
          // 勾選「全不」：清掉其它全部的 checked / error
          Object.keys(prev).forEach((k) => {
            next[k] = { ...prev[k] };
            if (k !== "allNone") {
              delete next[k].checked;
              delete next[k].error;
            }
          });
        }
        // 自己更新
        next.allNone = { ...prev.allNone, checked };

        // 清文字（保留你原本的 W6 不清邏輯）
        set60th_drugTxtObj((prevTxt) => {
          const t = { ...prevTxt };
          if (checked) {
            Object.keys(t).forEach((k) => {
              if (k !== "W6") {
                t[k] = { ...t[k], text: "", checked: false };
              }
            });
          }
          return t;
        });
      } else {
        // 勾到一般項目
        // 若 allNone 正在勾，先自動取消
        if (prev.allNone?.checked) {
          next.allNone = { ...prev.allNone, checked: false };
        }

        next[name] = {
          ...prev[name],
          checked,
          // 取消勾選就清錯；勾選則沿用舊錯誤（若有）
          error: checked ? (prev[name]?.error || false) : false,
        };

        // 若此項有對應文字欄位，維持你原本的限制：
        // - W4: 不同步文字欄位
        // - 其他 key: 有勾才保留既有文字；取消就清空
        set60th_drugTxtObj((prevTxt) => {
          if (!Object.prototype.hasOwnProperty.call(prevTxt, name) || name === "W4") {
            return prevTxt;
          }
          const curr = prevTxt[name] || {};
          return {
            ...prevTxt,
            [name]: {
              ...curr,
              checked,                                 // for 你 DB 導入格式
              text: checked ? (curr.text || "") : "",  // 取消則清空
            },
          };
        });
      }

      // —— 同步 group mirror：至少勾一項才算填 —— //
      const anyChecked = Object.values(next).some((it) => it?.checked === true);
      set4thValidator((prev4) => ({
        ...prev4,
        drug_allergy: {
          ...prev4.drug_allergy,
          checked: anyChecked,
          error: anyChecked ? false : prev4.drug_allergy.error,
          helperText: anyChecked ? "" : (prev4.drug_allergy.helperText || ""),
        },
      }));

      return next;
    });
  };
  const handleChangeTxt60th_drug = e => {  //第四區塊文字，抽取出來，改動文字不去觸發calculate_4th
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, value } = e.target;
      set60th_drugTxtObj({
        ...array60th_drugTxtObj,
        [name]: { ...array60th_drugTxtObj[name], text: value }
      })
    }
  }


  //家族病史，打勾部分
  const handleChange7th = e => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, checked } = e.target;
      // console.log(e.target);
      if (name === "allNone") {
        if (array7th.allNone.checked === false) {
          //其他: 不能勾選，除非allnone不勾
          //移除所以勾勾  
          _.forEach(array7th, function (value, key) {
            setArray7th(prevState => ({
              ...prevState,
              [key]: omit(value, ["checked", "error"]),
            }));
          });
          //移除所有文字
          _.forEach(array7thTxtObj, function (value, key) {
            if (key !== "W6") {
              set7thTxtObj(prevState => ({
                ...prevState,
                [key]: { ...value, text: "" }
              }));
            }

          });

          //自己勾上
          setArray7th(prevState => ({
            ...prevState,
            allNone: { ...prevState[name], checked: checked }
          }));
        } else {
          //自己取消，讓其他可以勾
          setArray7th(prevState => ({
            ...prevState,
            allNone: { ...prevState[name], checked: checked }
          }));
        }


      } else {
        setArray7th(prevState => ({
          ...prevState,
          allNone: { ...prevState.allNone, checked: false, error: false },
          [name]: {
            ...prevState[name], checked: checked,
            error: checked === false ? false : (prevState[name].error || false)
          }
        }))
        if (Object.keys(array7thTxtObj).includes(name)) {
          if (name !== "W6") {
            set7thTxtObj(prevState => ({
              ...prevState,
              [name]: {
                ...prevState[name],
                checked: checked,  //也要更新 for資料庫導入格式
                text: checked === false ? "" : (prevState[name].text || "")
              }
            }))
          }

        }
      }
    }
  }

  const handleChangeTxt7th = e => {  //第四區塊文字，抽取出來，改動文字不去觸發calculate_4th
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, value } = e.target;
      set7thTxtObj({
        ...array7thTxtObj,
        [name]: { ...array7thTxtObj[name], text: value }
      })
    }
  }
  //家族病史，打勾部分
  const handleChange8th = e => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, checked } = e.target;
      // console.log(e.target);
      if (name === "allNone") {
        if (array8th.allNone.checked === false) {
          //其他: 不能勾選，除非allnone不勾
          //移除所以勾勾  
          _.forEach(array8th, function (value, key) {
            setArray8th(prevState => ({
              ...prevState,
              [key]: omit(value, ["checked", "error"]),
            }));
          });
          //移除所有文字
          _.forEach(array8thTxtObj, function (value, key) {
            if (key !== "W6") {
              set8thTxtObj(prevState => ({
                ...prevState,
                [key]: { ...value, text: "" }
              }));
            }

          });

          //自己勾上
          setArray8th(prevState => ({
            ...prevState,
            allNone: { ...prevState[name], checked: checked }
          }));
        } else {
          //自己取消，讓其他可以勾
          setArray8th(prevState => ({
            ...prevState,
            allNone: { ...prevState[name], checked: checked }
          }));
        }


      } else {
        setArray8th(prevState => ({
          ...prevState,
          allNone: { ...prevState.allNone, checked: false, error: false },
          [name]: {
            ...prevState[name], checked: checked,
            error: checked === false ? false : (prevState[name].error || false)
          }
        }))
        if (Object.keys(array8thTxtObj).includes(name)) {
          if (name !== "W6") {
            set8thTxtObj(prevState => ({
              ...prevState,
              [name]: {
                ...prevState[name],
                checked: checked,  //也要更新 for資料庫導入格式
                text: checked === false ? "" : (prevState[name].text || "")
              }
            }))
          }

        }
      }
    }
  }
  const handleChangeTxt8th = e => {  //第四區塊文字，抽取出來，改動文字不去觸發calculate_4th
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, value } = e.target;
      set8thTxtObj({
        ...array8thTxtObj,
        [name]: { ...array8thTxtObj[name], text: value }
      })
    }
  }



  const [array4thValidator, set4thValidator] = React.useState({
    pastHistory: { name: "pastHistory", checked: false },
    conscious: { name: "conscious", checked: false },
    allergy: { name: "allergy", checked: false },
    drug_allergy: { name: "drug_allergy", checked: false },
    usage: { name: "usage", checked: false },
    family: { name: "family", checked: false },
  })
  const pastHistoryRef = useRef(null)
  const consciousRef = useRef(null)
  const allergyRef = useRef(null)
  const drug_allergyRef = useRef(null)
  const usageRef = useRef(null)
  const familyRef = useRef(null)


  const calculate_4th = () => {
    const total = Object.values(array4th).reduce((a, b) => a + (b.checked ? 1 : 0), 0)

    set4thValidator(prevState => ({
      ...prevState,
      pastHistory: { ...prevState.pastHistory, checked: total >= 1 ? true : false }
    }));
    if (total >= 1 && !array4thValidator.pastHistory.checked) {
      setNumerator(prev => prev + 1)
    } else if (total === 0 && array4thValidator.pastHistory.checked) {
      setNumerator(prev => prev - 1)
    }
  }
  React.useEffect(() => {
    if (!initialRender.current) {
      calculate_4th();
    }
  }, [array4th]); //避免循環

  //家族史的進度條
  const calculate_60th = () => {
    const total = Object.values(array60th).reduce((a, b) => a + (b.checked ? 1 : 0), 0)

    set4thValidator(prevState => ({
      ...prevState,
      allergy: { ...prevState.allergy, checked: total >= 1 ? true : false }
    }));
    if (total >= 1 && !array4thValidator.allergy.checked) {
      setNumerator(prev => prev + 1)
    } else if (total === 0 && array4thValidator.allergy.checked) {
      setNumerator(prev => prev - 1)
    }
  }
  React.useEffect(() => {
    if (!initialRender.current) {
      calculate_60th();
    }
  }, [array60th]); //避免循環


  //用藥史的進度條
  const calculate_7th = () => {
    const total = Object.values(array7th).reduce((a, b) => a + (b.checked ? 1 : 0), 0)

    set4thValidator(prevState => ({
      ...prevState,
      usage: { ...prevState.usage, checked: total >= 1 ? true : false }
    }));
    if (total >= 1 && !array4thValidator.usage.checked) {
      setNumerator(prev => prev + 1)
    } else if (total === 0 && array4thValidator.usage.checked) {
      setNumerator(prev => prev - 1)
    }
  }
  React.useEffect(() => {
    if (!initialRender.current) {
      calculate_7th();
    }
  }, [array7th]); //避免循環

  //家族史的進度條
  const calculate_8th = () => {
    const total = Object.values(array8th).reduce((a, b) => a + (b.checked ? 1 : 0), 0)

    set4thValidator(prevState => ({
      ...prevState,
      family: { ...prevState.family, checked: total >= 1 ? true : false }
    }));
    if (total >= 1 && !array4thValidator.family.checked) {
      setNumerator(prev => prev + 1)
    } else if (total === 0 && array4thValidator.family.checked) {
      setNumerator(prev => prev - 1)
    }
  }
  React.useEffect(() => {
    if (!initialRender.current) {
      calculate_8th();
    }
  }, [array8th]); //避免循環


  const w6Ref = useRef(null)
  const [array6th, setArray6th] = React.useState({
    A6: { label: "咳嗽", name: "A6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "咳嗽" }
    , B6: { label: "咳痰", name: "B6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "咳痰" }
    , C6: { label: "呼吸困難", name: "C6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "呼吸困難" }
    , E6: { label: "胸痛", name: "E6", type: "chkBox", gridWid: 3, systemLabel: "胸痛" }
    , F6: { label: "心悸", name: "F6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "心悸" }
    , G6: { label: "頭暈", name: "G6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "頭暈" }
    , H6: { label: "頭痛", name: "H6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "頭痛　" }
    , I6: { label: "耳鳴", name: "I6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "耳鳴　" }
    , J6: { label: "倦怠", name: "J6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "倦怠　" }
    , K6: { label: "噁心", name: "K6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "噁心　" }
    , L6: { label: "腹痛", name: "L6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "腹痛　" }
    , M6: { label: "便秘", name: "M6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "便秘　" }
    , O6: { label: "腹瀉", name: "O6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "腹瀉　" }
    , P6: { label: "血便", name: "P6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "血便　" }
    , Q6: { label: "上背痛", name: "Q6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "上背痛　" }
    , R6: { label: "下背痛", name: "R6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "下背痛　" }
    , S6: { label: "手腳麻痛", name: "S6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "手腳麻痛　" }
    , D6: { label: "關節疼痛", name: "D6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "關節疼痛　" }
    , N6: { label: "排尿不適", name: "N6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "排尿不適　" }
    , T6: { label: "多尿、頻尿", name: "T6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "多尿、頻尿　" }
    , V6: { label: "手腳肌肉無力", name: "V6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "手腳肌肉無力　" }
    , U6: { label: "體重減輕 3公斤以上", name: "U6", type: "chkBox", checked: false, checked: false, gridWid: 6, systemLabel: "體重減輕3公斤以上" }
    , W6: { label: "其他症狀", name: "W6", type: "chkBoxTxT", checked: false, checked: false, gridWid: 6, systemLabel: "其他症狀" }
    , allNone6: { label: "以上皆無", name: "allNone6", type: "chkBox", checked: false, gridWid: 12, systemLabel: "以上皆無" }
  });


  React.useEffect(() => {
    if (!initialRender.current) {
      const total = Object.values(array6th).reduce((a, b) => a + (b.checked ? 1 : 0), 0)
      set4thValidator(prevState => ({
        ...prevState,
        conscious: { ...prevState.conscious, checked: total >= 1 ? true : false }
      }));

      if (total >= 1 && !array4thValidator.conscious.checked) {
        setNumerator(prev => prev + 1)
      } else if (total === 0 && array4thValidator.conscious.checked) {
        setNumerator(prev => prev - 1)
      }
    }

  }, [array6th]); //避免循環

  const habitGridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(380px, 460px))",

    width: "100%",
    justifyContent: "start",
  };
  const habitCardStyle = {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    columnGap: "10px",
    rowGap: "6px",
    minWidth: 0,
  };
  const habitCheckStyle = {
    marginRight: "4px",
    flexShrink: 0,
  };

  const habitFieldStyle = {
    width: "120px",
    maxWidth: "100%",
  };



  const handleChange6th = e => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, checked } = e.target;
      // console.log(name, checked);
      if (name === "allNone6") {
        if (checked === true) {  //之前沒溝
          // console.log("allNon6自己溝上");
          //其他: 不能勾選，除非allnone不勾
          //移除所以勾勾  
          _.forEach(array6th, function (value, key) {
            setArray6th(prevState => ({
              ...prevState,
              [key]: omit(value, ["checked", "error"]),
            }));
          });
          //移除所有文字
          _.forEach(array4thTxtObj, function (value, key) {
            set4thTxtObj(prevState => ({
              ...prevState,
              W6: { ...value, text: "" }
            }));
          });

          //自己勾上
          setArray6th(prevState => ({
            ...prevState,
            allNone6: { ...prevState[name], checked: checked }
          }));
        } else {
          // console.log("allNon6自己取消");

          //自己取消，讓其他可以勾
          setArray6th(prevState => ({
            ...prevState,
            [name]: { ...prevState[name], checked: false }
          }));
        }


      } else {
        setArray6th(prevState => ({
          ...prevState,
          allNone6: { ...prevState.allNone6, checked: false, error: false },
          [name]: {
            ...prevState[name], checked: checked,
            error: checked === false ? false : (prevState[name].error || false)
          }
        }))
        if (Object.keys(array4thTxtObj).includes(name)) {
          set4thTxtObj(prevState => ({
            ...prevState,
            [name]: {
              ...prevState[name],
              text: checked === false ? "" : (prevState[name].text || "")
            }
          }))
        }
      }
    }
  }
  const checked3rdRef = useRef(null);
  const checked4rdRef = useRef(null);
  const occupationRef = useRef(null);
  const isMenstruatingRef = useRef(null);
  const lmpDateRef = useRef(null);
  const lmpOtherRef = useRef(null);
  const [openedDatePicker, setOpenedDatePicker] = React.useState(null);
  const preventDateTyping = event => {
    if (["Tab", "Shift", "Control", "Alt", "Meta", "Escape"].includes(event.key)) {
      return;
    }
    event.preventDefault();
  };
  const getDatePickerOpenProps = name => ({
    open: openedDatePicker === name,
    onOpen: () => setOpenedDatePicker(name),
    onClose: () => setOpenedDatePicker(null),
  });
  const getDatePickerInputProps = (name, inputProps = {}) => ({
    ...inputProps,
    inputMode: "none",
    style: { ...(inputProps.style || {}), cursor: "pointer" },
    onClick: () => setOpenedDatePicker(name),
    onKeyDown: preventDateTyping,
    onPaste: preventDateTyping,
  });
  const [checked3rd, setCheck3rd] = React.useState({
    checkA: null,
    checkB: null,
    error: false
  });

  const handleChangeThree = e => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, checked } = e.target;
      if (name === "checkA") {
        setCheck3rd(prevState => ({
          ...prevState,
          checkB: !checked,
          checkA: checked
        }))
        if (checked3rd.checkA === null) {
          setNumerator(prev => prev + 1);
        }
        if (checked) {
          //取消曾經
          // setWorkExp(prevState => ({
          //   ...prevState,
          //   usedJob: { ...prevState.usedJob, required: false },
          //   usedStart: { ...prevState.usedStart, required: false },
          //   usedEnd: { ...prevState.usedEnd, required: false }
          // }))
          // setDenominator(11);
          // //之前填過，若有數值，需-1
          // let ary = ["usedJob", "usedStart", "usedEnd"];
          // ary.map(item => {
          //   if (workExp[item].value !== "" && workExp[item].value !== null) {
          //     setNumerator(prev => prev - 1)
          //   }
          // })

        } else {
          // setWorkExp(prevState => ({
          //   ...prevState,
          //   usedJob: { ...prevState.usedJob, required: true },
          //   usedStart: { ...prevState.usedStart, required: true },
          //   usedEnd: { ...prevState.usedEnd, required: true }
          // }))
          //之前填過，若有數值，需+1
          // setDenominator(15);
          // let ary = ["usedJob", "usedStart", "usedEnd"];
          // ary.map(item => {
          //   if (workExp[item].value !== "" && workExp[item].value !== null && workExp[item].required !== true) {
          //     setNumerator(prev => prev + 1)
          //   }
          // })
        }
      } else {  //checkB定期檢查
        setCheck3rd(prevState => ({
          ...prevState,
          checkB: checked,
          checkA: !checked
        }))
        if (checked3rd.checkB === null) {
          setNumerator(prev => prev + 1);
        }
        if (checked) {
          //取消曾經
          // setWorkExp(prevState => ({
          //   ...prevState,
          //   usedJob: { ...prevState.usedJob, required: true },
          //   usedStart: { ...prevState.usedStart, required: true },
          //   usedEnd: { ...prevState.usedEnd, required: true }
          // }))
          // setDenominator(15);
          // let ary = ["usedJob", "usedStart", "usedEnd"];
          // ary.map(item => {
          //   if (workExp[item].value !== "" && workExp[item].value !== null && workExp[item].required !== true) {
          //     setNumerator(prev => prev + 1)
          //   }
          // })
        } else {
          // setWorkExp(prevState => ({
          //   ...prevState,
          //   usedJob: { ...prevState.usedJob, required: false },
          //   usedStart: { ...prevState.usedStart, required: false },
          //   usedEnd: { ...prevState.usedEnd, required: false }
          // }))
          // setDenominator(11);
          // let ary = ["usedJob", "usedStart", "usedEnd"];
          // ary.map(item => {
          //   if (workExp[item].value !== "" && workExp[item].value !== null) {
          //     setNumerator(prev => prev - 1)
          //   }
          // })
        }

      }
    }
  }



  const [array5_1, setArray5_1] = React.useState({
    smokeA: { name: "smokeA", label: "從未吸菸", type: "chkBox", checked: false, gridWid: 2, systemLabel: "從未吸菸　" }
    , smokeB: { name: "smokeB", label: "偶爾吸(不是天天)", type: "chkBox", checked: false, gridWid: 2, systemLabel: "偶爾吸(不是天天)　" }
    , smokeC: {
      systemLabel: "（幾乎）每天吸，平均每天吸＿支，已吸菸＿年",
      label: "(幾乎)每天吸", name: "smokeC", type: "chkBoxTxT", checked: false, gridWid: 8
      , type_1: "number", name_1: "smokeC_1", label_1: "平均每天吸", text_1: "", suffix1: "支", helperText_1: "", min_1: 1, ref: useRef(null)
      , type_2: "number", name_2: "smokeC_2", label_2: "已吸菸", text_2: "", suffix2: "年", helperText_2: "", max_2: 100, ref: useRef(null)
    }
    , smokeD: {
      systemLabel: "已經戒菸，戒了＿年＿個月。",
      label: "已經戒菸，戒了", name: "smokeD", type: "chkBoxTxT", checked: false, gridWid: 8
      , name_1: "smokeD_1", type_1: "number", label_1: " ", text_1: "", suffix1: "年", helperText_1: "", max_1: 100, ref: useRef(null)
      , name_2: "smokeD_2", type_2: "number", label_2: " ", text_2: "", suffix2: "個月", helperText_2: "", max_2: 12, ref: useRef(null) //label需有空格
    }
  });
  React.useEffect(() => {
    if (!initialRender.current) {
      const total = Object.values(array5_1).reduce((a, b) => a + (b.checked ? 1 : 0), 0)
      setArray5thCheck(prevState => ({
        ...prevState,
        smoke: { ...prevState.smoke, checked: total >= 1 ? true : false } //只更新這個
      }));
      if (total >= 1 && !array5thCheck.smoke.checked) {
        setNumerator(prev => prev + 1)
      } else if (total === 0) {
        setNumerator(prev => prev - 1)
      }
    }
  }, [array5_1]); //避免循環

  const handleChangeChk5_1 = e => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, checked } = e.target;
      //先移除所有checked
      const keys = Object.keys(array5_1);
      keys.map(item => {
        // console.log(item)
        delete array5_1[item].checked
      })
      //set
      setArray5_1({
        ...array5_1,
        [name]: { ...array5_1[name], checked: checked }
      });
      setArray5thCheck(prevState => ({
        ...prevState,
        smokeC_1: { ...prevState.smokeC_1, value: "", error: false },
        smokeC_2: { ...prevState.smokeC_2, value: "", error: false },
        smokeD_1: { ...prevState.smokeD_1, value: "", error: false },
        smokeD_2: { ...prevState.smokeD_2, value: "", error: false },
      }));

    }
  }
  // const smokeRef = useRef(null)
  // const betelRef = useRef(null)
  // const drunkRef = useRef(null)
  const [array5thCheck, setArray5thCheck] = React.useState({
    smoke: { name: "smoke", checked: false },
    smokeC_1: { name: "smokeC_1", value: "" },
    smokeC_2: { name: "smokeC_2", value: "" },
    smokeD_1: { name: "smokeD_1", value: "" },
    smokeD_2: { name: "smokeD_2", value: "" },
    betel: { name: "betel", checked: false },
    betelC_1: { name: "betelC_1", value: "" },
    betelC_2: { name: "betelC_2", value: "" },
    betelD_1: { name: "betelD_1", value: "" },
    betelD_2: { name: "betelD_2", value: "" },
    drunk: { name: "drunk", checked: false },
    drunkC_1: { name: "drunkC_1", value: "" },
    drunkC_2: { name: "drunkC_2", value: "" },
    drunkC_3: { name: "drunkC_3", value: "" },
    drunkD_1: { name: "drunkD_1", value: "" },
    drunkD_2: { name: "drunkD_2", value: "" },
    sleep: { name: "sleep", checked: false, value: "" },

  });
  const sleepRef = { smoke: useRef(), sleep: useRef(), drunk: useRef(), betel: useRef() }
  const handleChangeTxt5_4 = e => { //目前只5-4使用
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, value } = e.target;
      setArray5thCheck(prevState => ({
        ...prevState,
        [name]: { ...prevState[name], value: value }
      }));
      if (array5thCheck.sleep.value === "" && value !== "") {
        setNumerator(prev => prev + 1)
      } else if (value === "") {
        setNumerator(prev => prev - 1)
      }
      // console.log(array5thCheck)
    }
  }

  const handleChangeTxt5_1 = e => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, value } = e.target;
      setArray5thCheck(prevState => ({
        ...prevState,
        [name]: { ...prevState[name], value: value }
      }));
    }
  }



  const [array5_2, setArray5_2] = React.useState({
    betelA: { name: "betelA", label: "從未嚼食檳榔", type: "chkBox", checked: false, gridWid: 2, systemLabel: "從未嚼食檳榔　" }
    , betelB: { name: "betelB", label: "偶爾嚼(不是天天)", type: "chkBox", checked: false, gridWid: 2, systemLabel: "偶爾嚼(不是天天)　" }
    , betelC: {
      systemLabel: "(幾乎)每天嚼，平均每天嚼＿顆，已嚼＿年",
      label: "(幾乎)每天嚼", name: "betelC", type: "chkBoxTxT", checked: false, gridWid: 8
      , name_1: "betelC_1", type_1: "number", label_1: "平均每天嚼", text_1: "", suffix1: "顆", helperText_1: "", max_1: 100
      , name_2: "betelC_2", type_2: "number", label_2: "已嚼 ", text_2: "", suffix2: "年", helperText_2: "", max_2: 100
    }
    , betelD: {
      systemLabel: "已經戒食，戒了＿年＿個月。",
      label: "已經戒食，戒了", name: "betelD", type: "chkBoxTxT", checked: false, gridWid: 12
      , name_1: "betelD_1", type_1: "number", label_1: " ", text_1: "", suffix1: "年", helperText_1: "", max_1: 100
      , name_2: "betelD_2", type_2: "number", label_2: " ", text_2: "", suffix2: "個月", helperText_2: "", max_2: 12 //label需有空格
    }
  });

  React.useEffect(() => {
    if (!initialRender.current) {
      const total = Object.values(array5_2).reduce((a, b) => a + (b.checked ? 1 : 0), 0)
      setArray5thCheck(prevState => ({
        ...prevState,
        betel: { ...prevState.betel, checked: total >= 1 ? true : false } //只更新這個
      }))
      if (total >= 1 && !array5thCheck.betel.checked) {
        setNumerator(prev => prev + 1)
      } else if (total === 0) {
        setNumerator(prev => prev - 1)
      }
    }
  }, [array5_2]); //避免循環

  const handleChangeChk5_2 = e => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, checked } = e.target;
      //先移除所有checked
      const keys = Object.keys(array5_2);
      keys.map(item => {
        delete array5_2[item].checked
      }
      )
      //set
      setArray5_2({
        ...array5_2,
        [name]: {
          ...array5_2[name], checked: checked
        }
      })
      setArray5thCheck(prevState => ({
        ...prevState,
        betelC_1: { ...prevState.betelC_1, value: "", error: false },
        betelC_2: { ...prevState.betelC_2, value: "", error: false },
        betelD_1: { ...prevState.betelD_1, value: "", error: false },
        betelD_2: { ...prevState.betelD_2, value: "", error: false },
      }));
    }
  }

  // const handleChangeTxt5_2 = e => {
  //   if (_.isNil(imageURL)) {  //已提交不得修改
  //     const { name, value } = e.target;
  //     setArray5_2({
  //       ...array5_2,
  //       [name]: { ...array5_2[name], text_1: value }
  //     });
  //   }
  // }



  const [array5_3, setArray5_3] = React.useState({
    drunkA: { name: "drunkA", label: "從未喝酒", type: "chkBox", checked: false, gridWid: 2, systemLabel: "從未喝酒　" }
    , drunkB: { name: "drunkB", label: "偶爾喝(不是天天)", type: "chkBox", checked: false, gridWid: 2, systemLabel: "偶爾喝(不是天天)　" }
    , drunkC: {
      systemLabel: "（幾乎）每天喝，平均每週喝＿次，最常喝＿酒，每次＿瓶",
      label: "（幾乎）每天喝", name: "drunkC", type: "chkBoxTxT", checked: false, gridWid: 8
      , name_1: "drunkC_1", type_1: "number", label_1: "平均每週喝", suffix1: "次", max_1: 28
      , name_2: "drunkC_2", type_2: "text", label_2: "最常喝 ", suffix2: "酒"
      , name_3: "drunkC_3", type_3: "number", label_3: "每次 ", suffix3: "瓶", max_3: 100
    }
    , drunkD: {
      systemLabel: "已經戒酒，戒了＿年＿個月。",
      label: "已經戒酒，戒了", name: "drunkD", type: "chkBoxTxT", checked: false, gridWid: 12
      , name_1: "drunkD_1", type_1: "number", label_1: " ", suffix1: "年", max_1: 100
      , name_2: "drunkD_2", type_2: "number", label_2: " ", suffix2: "個月", max_2: 12//label需有空格
    }
  });
  React.useEffect(() => {
    if (!initialRender.current) {
      const total = Object.values(array5_3).reduce((a, b) => a + (b.checked ? 1 : 0), 0)
      setArray5thCheck(prevState => ({
        ...prevState,
        drunk: { ...prevState.drunk, checked: total >= 1 ? true : false } //只更新這個
      }));
      //ProgressBar
      if (total >= 1 && !array5thCheck.drunk.checked) {
        setNumerator(prev => prev + 1)
      } else if (total === 0) {
        setNumerator(prev => prev - 1)
      }
    }
  }, [array5_3]); //避免循環

  const handleChangeChk5_3 = e => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, checked } = e.target;
      //先移除所有checked
      const keys = Object.keys(array5_3);
      keys.map(item => {
        // console.log(item)
        delete array5_3[item].checked
      })
      //set
      setArray5_3(prevState => ({
        ...prevState,
        [name]: { ...prevState[name], checked: checked }
      }))
      setArray5thCheck(prevState => ({
        ...prevState,
        drunkC_1: { ...prevState.drunkC_1, value: "", error: false },
        drunkC_2: { ...prevState.drunkC_2, value: "", error: false },
        drunkC_3: { ...prevState.drunkC_3, value: "", error: false },
        drunkD_1: { ...prevState.drunkD_1, value: "", error: false },
        drunkD_2: { ...prevState.drunkD_2, value: "", error: false },
      }));

    }
  }
  // console.log(UserInfo.BarCodeStr)

  const { enqueueSnackbar } = useSnackbar();


  const convertToROC = (dateStr) => {
    const match = dateStr.match(/(\d{4})年(\d{2})月/);
    if (!match) return "格式錯誤";

    const year = parseInt(match[1], 10) - 1911; // 轉換為民國年
    const month = parseInt(match[2], 10);

    return `${year}/${month}`;
  }

  const getLMPValidationState = () => {
    if (formData.Gender !== "女") {
      return {
        shouldValidate: false,
        needIsMenstruatingError: false,
        needMainError: false,
        needOtherError: false,
      };
    }

    const hasIsMenstruating =
      formData.IsMenstruating === "是" || formData.IsMenstruating === "否";

    const hasDate =
      formData.LMPDate instanceof Date && !isNaN(formData.LMPDate.getTime());

    const flags =
      formData.LMPFlags && typeof formData.LMPFlags === "object"
        ? formData.LMPFlags
        : {
          Menopause: false,
          Pregnant: false,
          PostpartumNoPeriod: false,
          Other: false,
        };

    const hasAnyFlag = ["Menopause", "Pregnant", "PostpartumNoPeriod", "Other"].some(
      (k) => !!flags[k]
    );

    const otherSelected = !!flags.Other;
    const otherText = String(formData.LMPOtherText ?? "");
    const otherTextOk = otherText.trim().length > 0;

    const needIsMenstruatingError = !hasIsMenstruating;
    const needMainError = !hasDate && !hasAnyFlag;
    const needOtherError = otherSelected && !otherTextOk;

    return {
      shouldValidate: true,
      needIsMenstruatingError,
      needMainError,
      needOtherError,
    };
  };

  const getLMPInvalidRef = () => {
    const { needIsMenstruatingError, needMainError, needOtherError } = getLMPValidationState();

    if (needIsMenstruatingError) {
      return isMenstruatingRef;
    }
    if (needMainError) {
      return lmpDateRef;
    }
    if (needOtherError) {
      return lmpOtherRef;
    }
    return checked4rdRef;
  };

  const validateLMPGroup = () => {
    // 只驗女生
    console.log("[LMP] validateLMPGroup fired", {
      Gender: formData.Gender,
      IsMenstruating: formData.IsMenstruating,
      LMPDate: formData.LMPDate,
      LMPFlags: formData.LMPFlags,
      LMPOtherText: formData.LMPOtherText,
    });

    const {
      shouldValidate,
      needIsMenstruatingError,
      needMainError,
      needOtherError,
    } = getLMPValidationState();

    if (!shouldValidate) {
      setPersonal((prev) => ({
        ...prev,
        IsMenstruating: {
          ...prev.IsMenstruating,
          error: false,
          helperText: "",
        },
        LMPDate: {
          ...prev.LMPDate,
          error: false,
          helperText: "",
        },
        LMPFlags: {
          ...prev.LMPFlags,
          error: false,
          helperText: "",
        },
        LMPOtherText: {
          ...prev.LMPOtherText,
          error: false,
          helperText: "",
        },
      }));
      return true;
    }

    setPersonal((prev) => ({
      ...prev,
      IsMenstruating: {
        ...prev.IsMenstruating,
        error: needIsMenstruatingError,
        helperText: needIsMenstruatingError ? "請選擇目前是否為生理期" : "",
      },
      LMPDate: {
        ...prev.LMPDate,
        error: needMainError,
        helperText: needMainError ? "請選擇日期或勾選下方狀態" : "",
      },
      LMPFlags: {
        ...prev.LMPFlags,
        error: needMainError,
        helperText: needMainError ? "請選擇日期或勾選下方狀態" : "",
      },
      LMPOtherText: {
        ...prev.LMPOtherText,
        error: needOtherError,
        helperText: needOtherError ? "請填寫其他狀況" : "",
      },
    }));

    return !(needIsMenstruatingError || needMainError || needOtherError);
  };

  const formRef = React.createRef();
  const handleSubmit = (e) => {

    // console.log(formData.LMPDate, Object.keys(formData.LMPFlags)
    //   .find((key) => formData.LMPFlags[key]) || "unknown", formData.LMPOtherText)
    console.log(PF.url)
    e.preventDefault();
    if (validator()) {

      if (isShown) {
        let X = {
          Action: "GET",
          parameter: {
            barcodestr: UserInfo.BarCodeStr
          }
        }
        PF.instance({
          method: "post",
          url: PF.url + "/LabourCheck/QuestionRecord",
          data: Qs.stringify(X),
        })
          .then(function (response) {
            const { TotalRecord, rows } = response.data;
          })
      }

      UpdateRelation()

      //清除
      dispatch(actions.TAB_EDIT({ editing: true, key: 80 }))
      Update80th();
      //更新部分資料至CheckProjectDetail
      UpdateProjectDetail();

      // handleNext("",80);
    }

  }

  const getLMPText = (formData) => {
    if (formData.Gender !== '女') return ''
    console.log('進入')
    if (formData.LMPDate) {
      const d = new Date(formData.LMPDate)
      const date = `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}`
      return `\n最後一次月經: ${date}`
    }
    console.log('最後一次')
    const f = formData.LMPFlags || {}
    if (f.Menopause) return '\n最後一次月經: 停經'
    if (f.Pregnant) return '\n最後一次月經: 懷孕中'
    if (f.PostpartumNoPeriod) return '\n最後一次月經: 產後/哺乳中目前無月經'
    if (f.Other) return `\n最後一次月經: 其他:${formData.LMPOtherText || ''}`
    console.log('最後一次2')
    return ''
  }

  const UpdateProjectDetail = prop => {
    //section 5
    //抽菸
    let fiveth_1 = Object.values(array5_1).reduce((a, b) => a + (b.checked ? "||" + b.systemLabel : ""), "");
    let Str_fiveth_1 = fiveth_1.substring(2, 999);
    let _count_5_1 = (fiveth_1.substring(2, 999).match(/＿/g) || []).length
    let fiveth_1Txt = Object.values(array5thCheck).slice(1, 5).reduce((a, b) => a + (b.value !== "" ? "||" + b.value : ""), "");
    let fiveth_1TxtArray = fiveth_1Txt.substring(2, 999).split("||");
    for (let step = 0; step < _count_5_1; step++) {
      let t = 0;
      Str_fiveth_1 = Str_fiveth_1.replace(/＿/g, match => ++t === 1 ? fiveth_1TxtArray[step] : match)
    }
    // console.log(Str_fiveth_1);

    //檳榔
    let fiveth_2 = Object.values(array5_2).reduce((a, b) => a + (b.checked ? "||" + b.systemLabel : ""), "");
    let Str_fiveth_2 = fiveth_2.substring(2, 999);
    let _count_5_2 = (fiveth_2.substring(2, 999).match(/＿/g) || []).length
    let fiveth_2Txt = Object.values(array5thCheck).slice(6, 10).reduce((a, b) => a + (b.value !== "" ? "||" + b.value : ""), "");
    let fiveth_2TxtArray = fiveth_2Txt.substring(2, 999).split("||");
    for (let step = 0; step < _count_5_2; step++) {
      let t = 0;
      Str_fiveth_2 = Str_fiveth_2.replace(/＿/g, match => ++t === 1 ? fiveth_2TxtArray[step] : match)
    }
    // console.log(Str_fiveth_2);

    //喝酒
    let fiveth_3 = Object.values(array5_3).reduce((a, b) => a + (b.checked ? "||" + b.systemLabel : ""), "");
    let Str_fiveth_3 = fiveth_3.substring(2, 999);
    let _count_5_3 = (fiveth_3.substring(2, 999).match(/＿/g) || []).length
    let fiveth_3Txt = Object.values(array5thCheck).slice(11, 16).reduce((a, b) => a + (b.value !== "" ? "||" + b.value : ""), "");
    let fiveth_3TxtArray = fiveth_3Txt.substring(2, 999).split("||");
    for (let step = 0; step < _count_5_3; step++) {
      let t = 0;
      Str_fiveth_3 = Str_fiveth_3.replace(/＿/g, match => ++t === 1 ? fiveth_3TxtArray[step] : match)
    }


    //LMP(最近一次月經第一天) 加到 2031生活習慣
    const LMPText = getLMPText(formData)


    //console.log(Str_fiveth_3);
    //睡眠2043
    let Str_fiveth_4 = "平均每天睡眠時間為：＿小時。".replace(/＿/g, array5thCheck.sleep.value)
    // console.log(Str_fiveth_4);

    //自覺症狀2008
    let Sixth = Object.values(array6th).reduce((a, b) => a + (b.checked ? "、" + b.systemLabel : ""), "");
    let Str_6th = Sixth.substring(1, 999).replace(/以上皆無/g, "無");
    Str_6th = Str_6th.replace(/其他症狀/g, "其他症狀:" + array4thTxtObj.W6.text);
    // console.log(Str_6th.replace(/　/g, ""));

    //過敏史
    let Sixth0 = Object.values(array60th).reduce((a, b) => a + (b.checked ? "" + b.systemLabel : ""), "");
    let Sixth0Txt = Object.values(array60thTxtObj).reduce((a, b) => a + ("" + b.text), "");
    // console.log(Sixth0 + " " + Sixth0Txt)

    //藥物過敏
    let Sixth0_drug = Object.values(array60th_drug).reduce((a, b) => a + (b.checked ? "" + b.systemLabel : ""), "");
    let Sixth0Txt_drug = Object.values(array60th_drugTxtObj).reduce((a, b) => a + ("" + b.text), "");

    // let Seventh = Object.values(array7th).reduce((a, b) => a + (b.checked ? "||" + b.type == 'chkBoxTxT' ? '其他：' + array7thTxtObj.U4.text : b.systemLabel : ""), "");
    let string7 = ''
    let Seventh = Object.values(array7th).forEach(item => {
      string7 += item.checked ? item.name === 'U7' ? "其他:" + array7thTxtObj.U7.text + '||' : item.systemLabel + '||' : ''
    })
    // console.log(string7.replace(/　/g, "").replaceAll("||", "、").slice(0, -1))

    let string8 = ''
    let Eighth = Object.values(array8th).forEach(item => {
      string8 += item.checked ? Object.keys(array8thTxtObj).includes(item.name) ? item.systemLabel + ":" + array8thTxtObj[item.name].text + '||' : item.systemLabel + '||' : ''
    })
    // console.log(string8.replace(/　/g, "").replaceAll("||", "、").slice(0, -1))
    let string4 = ''
    let Four = Object.values(array4th).forEach(item => {
      string4 += item.checked ? Object.keys(array4thTxtObj).includes(item.name) ? item.systemLabel + ":" + array4thTxtObj[item.name].text + '||' : item.systemLabel + '||' : ''
    })

    //曾經從事
    let Str_everwork = ''

    // console.log(Str_everwork)
    //目前從事
    let Str_nowwork = ''
    // console.log(Str_nowwork)
    //過去1個月，平均每週工時 2052
    let Str_onemonth = "過去1個月，平均每週工時為＿小時".replace(/＿/g, workExp.workhours_1.value)
    // console.log(Str_onemonth);
    let Str_sixmonth = "過去6個月，平均每週工時為＿小時".replace(/＿/g, workExp.workhours_2.value)
    // console.log(Str_sixmonth);
    var UpdateList = []
    if (isShown) {

      Str_nowwork = workExp.rightNowJob.value + ' ' + convertToROC(workExp.rightNowStart.value) + '~--/--'
      if (forgot) {
        Str_everwork = workExp.usedJob.value + '(忘記日期)'
      }
      else if (NoJob) {
        Str_everwork = '無工作經驗'
      }
      else {
        Str_everwork = workExp.usedJob.value + ' ' + convertToROC(workExp.usedStart.value) + '~' + convertToROC(workExp.usedEnd.value)
      }


      UpdateList = [
        { BarCodeStr: UserInfo.BarCodeStr, ItemNo: "2008", Value: Str_6th.replace(/　/g, "") },
        { BarCodeStr: UserInfo.BarCodeStr, ItemNo: "2043", Value: Str_fiveth_4 },
        {
          BarCodeStr: UserInfo.BarCodeStr, ItemNo: "2031",
          Value:
            Str_fiveth_1.replace(/　/g, "") + '、' +
            Str_fiveth_2.replace(/　/g, "") + '、' +
            Str_fiveth_3.replace(/　/g, "") +
            '。' + LMPText
        },
        { BarCodeStr: UserInfo.BarCodeStr, ItemNo: "2049", Value: Sixth0 + " " + Sixth0Txt },
        { BarCodeStr: UserInfo.BarCodeStr, ItemNo: "2056", Value: Sixth0_drug + " " + Sixth0Txt_drug },
        { BarCodeStr: UserInfo.BarCodeStr, ItemNo: "2050", Value: string7.replace(/　/g, "").replaceAll("||", "、").slice(0, -1) },
        { BarCodeStr: UserInfo.BarCodeStr, ItemNo: "2051", Value: string8.replace(/　/g, "").replaceAll("||", "、").slice(0, -1) },
        { BarCodeStr: UserInfo.BarCodeStr, ItemNo: "2013", Value: string4.replace(/　/g, "").replaceAll("||", "、").slice(0, -1) },
        { BarCodeStr: UserInfo.BarCodeStr, ItemNo: "2052", Value: Str_everwork },
        { BarCodeStr: UserInfo.BarCodeStr, ItemNo: "2053", Value: Str_nowwork },
        { BarCodeStr: UserInfo.BarCodeStr, ItemNo: "2054", Value: Str_onemonth },
        { BarCodeStr: UserInfo.BarCodeStr, ItemNo: "2055", Value: Str_sixmonth }
      ]
    } else {
      UpdateList = [
        { BarCodeStr: UserInfo.BarCodeStr, ItemNo: "2008", Value: Str_6th.replace(/　/g, "") },
        { BarCodeStr: UserInfo.BarCodeStr, ItemNo: "2043", Value: Str_fiveth_4 },
        {
          BarCodeStr: UserInfo.BarCodeStr, ItemNo: "2031",
          Value:
            Str_fiveth_1.replace(/　/g, "") + '、' +
            Str_fiveth_2.replace(/　/g, "") + '、' +
            Str_fiveth_3.replace(/　/g, "") +
            '。' + LMPText
        },
        { BarCodeStr: UserInfo.BarCodeStr, ItemNo: "2049", Value: Sixth0 + " " + Sixth0Txt },
        { BarCodeStr: UserInfo.BarCodeStr, ItemNo: "2056", Value: Sixth0_drug + " " + Sixth0Txt_drug },
        { BarCodeStr: UserInfo.BarCodeStr, ItemNo: "2050", Value: string7.replace(/　/g, "").replaceAll("||", "、").slice(0, -1) },
        { BarCodeStr: UserInfo.BarCodeStr, ItemNo: "2051", Value: string8.replace(/　/g, "").replaceAll("||", "、").slice(0, -1) },
        { BarCodeStr: UserInfo.BarCodeStr, ItemNo: "2013", Value: string4.replace(/　/g, "").replaceAll("||", "、").slice(0, -1) },
      ]
    }



    //更新醫生問診
    PF.instance({
      method: "post",
      url: PF.url + "/Questionaire/Update",
      data: Qs.stringify({ list: UpdateList }),
      headers: { token: sessionStorage.token }
    })
      .then(function (response) {
        // console.log(response.data)
        const { Total, rows, error } = response.data;
        console.log(Total, rows)
        // if (TotalRecord <= 0) {
        //   // alert("問卷提交出錯\r\n" + ErrorMessage + "請致電 04-2255-2555 #168 企業健檢")
        //   enqueueSnackbar(intl.formatMessage({ id: "update fail" }), { variant: "error", style: { whiteSpace: 'pre-line' } });
        // } else {
        //   setActiveStep((prevActiveStep) => prevActiveStep + 1);
        //   setImage("Image");
        //   enqueueSnackbar(intl.formatMessage({ id: "update success" }), { variant: "success", style: { whiteSpace: 'pre-line' } });
        // }
      })

  }

  const validator = () => {
    console.log("[VALIDATOR] checkValidity =", formRef.current?.checkValidity());
    const form = formRef.current; //參數1
    // console.log(form.checkValidity())
    const nativeOk = form.checkValidity();     // ⭐ 原生驗證結果
    const lmpOk = validateLMPGroup();          // ⭐ LMP 組合驗證（女生才會真正檢查）
    const workDateRangeOk = !isWorkDateRangeInvalid(workExp);

    // ⭐ 合併結果：兩個都要過才算過
    const allOk = nativeOk && lmpOk && workDateRangeOk;

    if (allOk) {
      console.log("全部通過");
      if (form.checkValidity()) {
        console.log("全部通過")
        //若驗證通過，刪除錯誤提示
        for (let i = 0; i < form.elements.length; i++) {
          const element = form.elements[i];

          if (Object.keys(personal).includes(element.name)) {
            setPersonal(prevState => ({
              ...prevState,
              [element.name]: omit(prevState[element.name], ["error"])
            }));
          }
          if (element.name === "YN") {
            setShiftChk(prev => ({
              ...prev,
              [element.name]: omit(prev.YN, ["error"])
            }))
          }
          if (element.name === "YesShiftChkObjAll") {
            setYesShiftChkObjAll(prev => (
              { ...prev, error: false }
            ))
          }
          if (element.name === "ShiftOther") {
            setYesShiftChkObj(prev => ({
              ...prev,
              [element.name]: omit(prev[element.name], ["error"])
            }))
          }
          if (Object.keys(workExp).includes(element.name)) {
            setWorkExp(prevState => ({
              ...prevState,
              [element.name]: omit(prevState[element.name], ["error"])
            }))
          }
          if (element.name === "checked3rd") {
            setCheck3rd(prevState => (omit(prevState, ["error"])))
          }
          if (element.name === "pastHistory") {
            set4thValidator(prevState => ({
              ...prevState,
              pastHistory: (omit(prevState.pastHistory, ["error"]))
            }))
          }
          if (Object.keys(array4th).includes(element.name)) {
            setArray4th(prevState => ({
              ...prevState,
              [element.name]: omit(prevState[element.name], ["error"])
            }))
          }
          if (Object.keys(array5thCheck).includes(element.name)) {
            setArray5thCheck(prevState => ({
              ...prevState,
              [element.name]: omit(prevState[element.name], ["error"])
            }));
          }
          if (element.name === "conscious") {
            set4thValidator(prevState => ({
              ...prevState,
              conscious: (omit(prevState.conscious, ["error"]))
            }))
          }
          if (Object.keys(array6th).includes(element.name)) {
            setArray6th(prevState => ({
              ...prevState,
              [element.name]: omit(prevState[element.name], ["error"])
            }))
          }

          if (Object.keys(array60th).includes(element.name)) {
            setArray60th(prevState => ({
              ...prevState,
              [element.name]: omit(prevState[element.name], ["error"])
            }))
          }
          if (Object.keys(array60th_drug).includes(element.name)) {
            setArray60th_drug(prevState => ({
              ...prevState,
              [element.name]: omit(prevState[element.name], ["error"])
            }))
          }
          if (element.name === "allergy") {
            set4thValidator(prevState => ({
              ...prevState,
              allergy: (omit(prevState.allergy, ["error"]))
            }))
          }
          if (element.name === "drug_allergy") {
            set4thValidator(prevState => {
              console.log("drug_allergy state:", prevState.drug_allergy);
              return {
                ...prevState,
                drug_allergy: (omit(prevState.drug_allergy, ["error"]))
              }
            });
          }
          if (Object.keys(array7th).includes(element.name)) {
            setArray7th(prevState => ({
              ...prevState,
              [element.name]: omit(prevState[element.name], ["error"])
            }))
          }
          if (element.name === "usage") {
            set4thValidator(prevState => ({
              ...prevState,
              usage: (omit(prevState.usage, ["error"]))
            }))
          }
          if (Object.keys(array8th).includes(element.name)) {
            setArray8th(prevState => ({
              ...prevState,
              [element.name]: omit(prevState[element.name], ["error"])
            }))
          }
          if (element.name === "family") {
            set4thValidator(prevState => ({
              ...prevState,
              family: (omit(prevState.family, ["error"]))
            }))
          }
        }
      }
      return true;
    } else {
      // const form = formRef.current;
      // console.log("還沒通過")
      // alert("尚有問題未完成");
      alert(intl.formatMessage({ id: "尚有問題未完成" }));
      const scrollPriority = {
        basic: 1,
        work: 2,
        workDateRange: 2.5,
        checked3rd: 3,
        personal: 4,
        lmp: 4.5,
        pastHistory: 5,
        lifestyle: 6,
        conscious: 7,
        allergy: 8,
        drugAllergy: 9,
        usage: 10,
        family: 11,
      };
      let invalidScrollTarget = null;
      const scrollToInvalid = (targetRef, options = { behavior: "smooth" }, priority = 999) => {
        if (!targetRef?.current) {
          return;
        }
        if (!invalidScrollTarget || priority < invalidScrollTarget.priority) {
          invalidScrollTarget = { targetRef, options, priority };
        }
      };
      const getElementScrollRef = element => {
        if (!element) {
          return null;
        }
        const target = element.closest?.("label")
          || element.closest?.(".MuiFormControl-root")
          || element.closest?.(".MuiGrid-item")
          || element;
        return target ? { current: target } : null;
      };
      const getNamedElementScrollRef = name => {
        const control = form.elements[name];
        const element = control?.tagName
          ? control
          : control?.length
            ? Array.from(control).find(item => item?.willValidate) || control[0]
            : null;
        return getElementScrollRef(element);
      };
      const getWorkDateRangeScrollRef = () => {
        if (isUsedDateRangeInvalid(workExp)) {
          return getNamedElementScrollRef("usedEnd") || getNamedElementScrollRef("usedStart") || workRef;
        }
        if (isUsedEndRightNowStartInvalid(workExp)) {
          return getNamedElementScrollRef("rightNowStart") || getNamedElementScrollRef("usedEnd") || workRef;
        }
        return workRef;
      };
      if (!lmpOk) {
        scrollToInvalid(getLMPInvalidRef(), { behavior: "smooth", block: "center" }, scrollPriority.lmp);
      }
      if (!workDateRangeOk) {
        setWorkExp(prevState => applyWorkDateRangeError(prevState));
        scrollToInvalid(getWorkDateRangeScrollRef(), { behavior: "smooth", block: "center" }, scrollPriority.workDateRange);
      }
      for (let i = 0; i < form.elements.length; i++) {
        const element = form.elements[i];
        if (element.tagName !== 'button' && element.willValidate && !element.validity.valid) {  //提交按鈕不用驗證
          // console.log(element.validationMessage, element.name);
          // console.log(element.value)
          // console.log(element.value, element.validationMessage, element.name, element.tagName)

          if (element.name === "YN") {
            setShiftChk(prev => ({
              ...prev,
              [element.name]: { ...prev[element.name], error: true, helperText: element.validationMessage }
            }))
            scrollToInvalid(getElementScrollRef(element), { behavior: 'smooth', block: 'center' }, scrollPriority.work);
          }
          if (element.name === "YesShiftChkObjAll") {
            setYesShiftChkObjAll(prev => (
              { ...prev[element.name], error: true, helperText: element.validationMessage }
            ))
            scrollToInvalid(getElementScrollRef(element), { behavior: 'smooth', block: 'center' }, scrollPriority.work);
          }
          if (element.name === "ShiftOther") {
            setYesShiftChkObj(prev => ({
              ...prev,
              [element.name]: { ...prev[element.name], error: true, helperText: element.validationMessage }
            }))
            scrollToInvalid(getElementScrollRef(element), { behavior: 'smooth', block: 'center' }, scrollPriority.work);
          }

          if (Object.keys(personal).includes(element.name)) {
            // console.log(element.name);
            setPersonal(prevState => ({
              ...prevState,
              [element.name]: { ...prevState[element.name], error: true, helperText: element.validationMessage }
            }))
            const personalPriority = ["CustName", "hireDate"].includes(element.name)
              ? scrollPriority.basic
              : scrollPriority.personal;
            scrollToInvalid(getElementScrollRef(element), { behavior: 'smooth', block: 'center' }, personalPriority);
          }
          if (Object.keys(workExp).includes(element.name)) {
            setWorkExp(prevState => ({
              ...prevState,
              [element.name]: { ...prevState[element.name], error: true, helperText: element.validationMessage }
            }))
            scrollToInvalid(getElementScrollRef(element), { behavior: 'smooth', block: 'center' }, scrollPriority.work);
          }
          if (element.name === "checked3rd") {
            setCheck3rd(prevState => ({
              ...prevState,
              error: true, helperText: element.validationMessage
            }));
            scrollToInvalid(getElementScrollRef(element) || checked3rdRef, { behavior: 'smooth', block: 'center' }, scrollPriority.checked3rd);
          }
          if (element.name === "phonenum" || element.name === "name" || element.name === "otherRelationship" || element.name === "relationship" || element.name === "BloodType" || element.name === "Occupation" || element.name === "OwnPhone") {
            const personalScrollRef = element.name === "Occupation" ? occupationRef : checked4rdRef;
            const personalScrollOptions = element.name === "Occupation"
              ? { behavior: 'smooth', block: 'center' }
              : { behavior: 'smooth' };
            scrollToInvalid(personalScrollRef, personalScrollOptions, scrollPriority.personal);
          }
          if (element.name === "pastHistory") {
            set4thValidator(prevState => ({
              ...prevState,
              [element.name]: { ...prevState[element.name], error: true, helperText: element.validationMessage }
            }));
            scrollToInvalid(getElementScrollRef(element) || pastHistoryRef, { behavior: 'smooth', block: 'center' }, scrollPriority.pastHistory);
          }
          if (Object.keys(array4th).includes(element.name)) {
            setArray4th(prevState => ({
              ...prevState,
              [element.name]: { ...prevState[element.name], error: true, helperText: element.validationMessage }
            }))
            scrollToInvalid(getElementScrollRef(element), { behavior: 'smooth', block: 'center' }, scrollPriority.pastHistory);
          }
          if (Object.keys(array5thCheck).includes(element.name)) {
            setArray5thCheck(prevState => ({
              ...prevState,
              [element.name]: { ...prevState[element.name], error: true, helperText: element.validationMessage }
            }));
            if (["smoke", "sleep", "drunk", "betel"].includes(element.name)) {
              scrollToInvalid(getElementScrollRef(element) || sleepRef[element.name], { behavior: 'smooth', block: 'center' }, scrollPriority.lifestyle)
            } else {
              scrollToInvalid(getElementScrollRef(element), { behavior: 'smooth', block: 'center' }, scrollPriority.lifestyle)
            }
            // console.log(element.name);
          }
          if (element.name === "conscious") {
            set4thValidator(prevState => ({
              ...prevState,
              [element.name]: { ...prevState[element.name], error: true, helperText: element.validationMessage }
            }));
            scrollToInvalid(getElementScrollRef(element) || consciousRef, { behavior: 'smooth', block: 'center' }, scrollPriority.conscious)
          }
          if (Object.keys(array6th).includes(element.name)) {
            setArray6th(prevState => ({
              ...prevState,
              [element.name]: { ...prevState[element.name], error: true, helperText: element.validationMessage }
            }))
            console.log(element.name)
            if (element.name === "W6") {
              scrollToInvalid(getElementScrollRef(element) || w6Ref, { behavior: 'smooth', block: 'center' }, scrollPriority.conscious)
            } else {
              scrollToInvalid(getElementScrollRef(element), { behavior: 'smooth', block: 'center' }, scrollPriority.conscious)
            }
          }
          if (Object.keys(array60th).includes(element.name)) {
            setArray60th(prevState => ({
              ...prevState,
              [element.name]: { ...prevState[element.name], error: true, helperText: element.validationMessage }
            }))
            scrollToInvalid(getElementScrollRef(element), { behavior: 'smooth', block: 'center' }, scrollPriority.allergy);
          }
          if (Object.keys(array60th_drug).includes(element.name)) {
            setArray60th_drug(prevState => ({
              ...prevState,
              [element.name]: { ...prevState[element.name], error: true, helperText: element.validationMessage }
            }))
            scrollToInvalid(getElementScrollRef(element), { behavior: 'smooth', block: 'center' }, scrollPriority.drugAllergy);
          }
          if (Object.keys(array7th).includes(element.name)) {
            setArray7th(prevState => ({
              ...prevState,
              [element.name]: { ...prevState[element.name], error: true, helperText: element.validationMessage }
            }))
            scrollToInvalid(getElementScrollRef(element), { behavior: 'smooth', block: 'center' }, scrollPriority.usage);
          }
          if (Object.keys(array8th).includes(element.name)) {
            setArray8th(prevState => ({
              ...prevState,
              [element.name]: { ...prevState[element.name], error: true, helperText: element.validationMessage }
            }))
            scrollToInvalid(getElementScrollRef(element), { behavior: 'smooth', block: 'center' }, scrollPriority.family);
          }
          if (element.name === "allergy") {
            set4thValidator(prevState => ({
              ...prevState,
              [element.name]: { ...prevState[element.name], error: true, helperText: element.validationMessage }
            }));
            scrollToInvalid(getElementScrollRef(element) || allergyRef, { behavior: 'smooth', block: 'center' }, scrollPriority.allergy)
          }
          if (element.name === "drug_allergy") {
            set4thValidator(prevState => ({
              ...prevState,
              [element.name]: { ...prevState[element.name], error: true, helperText: element.validationMessage }
            }));
            scrollToInvalid(getElementScrollRef(element) || drug_allergyRef, { behavior: 'smooth', block: 'center' }, scrollPriority.drugAllergy)
          }
          if (element.name === "usage") {
            set4thValidator(prevState => ({
              ...prevState,
              [element.name]: { ...prevState[element.name], error: true, helperText: element.validationMessage }
            }));
            scrollToInvalid(getElementScrollRef(element) || usageRef, { behavior: 'smooth', block: 'center' }, scrollPriority.usage)
          }
          if (element.name === "family") {
            set4thValidator(prevState => ({
              ...prevState,
              [element.name]: { ...prevState[element.name], error: true, helperText: element.validationMessage }
            }));
            scrollToInvalid(getElementScrollRef(element) || familyRef, { behavior: 'smooth', block: 'center' }, scrollPriority.family)
          }

        } else {//驗證通過，自訂訊息
          //有在settingObj的
          // console.log("Pass", element.value, element.validationMessage, element.name, element.tagName)

          if (element.name === "YN") {
            setShiftChk(prev => ({
              ...prev,
              [element.name]: omit(prev.YN, ["error"])
            }))
          }

          if (element.name === "YesShiftChkObjAll") {
            setYesShiftChkObjAll(prev => (
              { ...prev, error: false }
            ))
          }
          if (element.name === "ShiftOther") {
            setYesShiftChkObj(prev => ({
              ...prev,
              [element.name]: omit(prev[element.name], ["error"])
            }))
          }
          if (Object.keys(personal).includes(element.name)) {
            setPersonal(prevState => ({
              ...prevState,
              [element.name]: omit(prevState[element.name], ["error"])
            }));
          }
          if (Object.keys(workExp).includes(element.name)) {
            setWorkExp(prevState => ({
              ...prevState,
              [element.name]: omit(prevState[element.name], ["error"])
            }))
          }
          if (element.name === "checked3rd") {
            setCheck3rd(prevState => (omit(prevState, ["error"])))
          }
          if (element.name === "pastHistory") {
            set4thValidator(prevState => ({
              ...prevState,
              pastHistory: (omit(prevState.pastHistory, ["error"]))
            }))
          }
          if (Object.keys(array4th).includes(element.name)) {

            setArray4th(prevState => ({
              ...prevState,
              [element.name]: omit(prevState[element.name], ["error"])
            }))
          }

          if (Object.keys(array60th).includes(element.name)) {
            console.log(123)
            setArray60th(prevState => ({
              ...prevState,
              [element.name]: omit(prevState[element.name], ["error"])
            }))
          }
          if (Object.keys(array60th_drug).includes(element.name)) {
            console.log(122)
            setArray60th_drug(prevState => ({
              ...prevState,
              [element.name]: omit(prevState[element.name], ["error"])
            }))
          }
          if (Object.keys(array7th).includes(element.name)) {
            console.log(121)
            setArray7th(prevState => ({
              ...prevState,
              [element.name]: omit(prevState[element.name], ["error"])
            }))
          }
          if (Object.keys(array8th).includes(element.name)) {
            setArray8th(prevState => ({
              ...prevState,
              [element.name]: omit(prevState[element.name], ["error"])
            }))
          }
          if (Object.keys(array5thCheck).includes(element.name)) {
            setArray5thCheck(prevState => ({
              ...prevState,
              [element.name]: omit(prevState[element.name], ["error"])
            }));
          }
          if (element.name === "conscious") {
            set4thValidator(prevState => ({
              ...prevState,
              conscious: (omit(prevState.conscious, ["error"]))
            }))

          }
          if (Object.keys(array6th).includes(element.name)) {
            setArray6th(prevState => ({
              ...prevState,
              [element.name]: omit(prevState[element.name], ["error"])
            }))
          }
          if (element.name === "allergy") {
            set4thValidator(prevState => ({
              ...prevState,
              allergy: (omit(prevState.allergy, ["error"]))
            }))
          }
          if (element.name === "drug_allergy") {
            set4thValidator(prevState => ({
              ...prevState,
              drug_allergy: (omit(prevState.drug_allergy, ["error"]))
            }))
          }
          if (element.name === "usage") {
            set4thValidator(prevState => ({
              ...prevState,
              usage: (omit(prevState.usage, ["error"]))
            }))
          }
          if (element.name === "family") {
            set4thValidator(prevState => ({
              ...prevState,
              family: (omit(prevState.family, ["error"]))
            }))
          }

        }
      }
      if (!workDateRangeOk) {
        setWorkExp(prevState => applyWorkDateRangeError(prevState));
      }
      invalidScrollTarget?.targetRef.current.scrollIntoView(invalidScrollTarget.options);
      return false;
    }
  }
  const [personal, setPersonal] = React.useState({
    CustName: { name: "CustName", value: UserInfo.CustName },
    // personalID: { name: "personalID", value: "" },
    // birthDate: { name: "birthDate", label: "4.出生日期", required: true, value: null, maxDate: new Date() },
    hireDate: { name: "hireDate", label: "2.受僱日期", required: true, value: null, disableFuture: true, maxDate: new Date() },
    // examinationDate: { name: "examinationDate", label: "6. 體檢日期", required: true, value: null, minDate: new Date() }
    name: {},
    relationship: {},
    phonenum: {},
    otherRelationship: {},
    Occupation: {},
    OwnPhone: {},
    BloodType: {},
    IsMenstruating: {},
  })
  const handleDateChange = (name, e, v) => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      setPersonal(prevState => ({
        ...prevState,
        [name]: {
          ...prevState[name],
          value: v
        }
      }));
      if ((personal.hireDate.value === "" || personal.hireDate.value === null) && (v === "" || v === null)) {
        return
      }
      if ((personal.hireDate.value === "" || personal.hireDate.value === null) && (v !== null || v !== "") && personal.hireDate.required === true) {
        setNumerator(prev => prev + 1)
      } else if ((v === "" || v === null) && personal.hireDate.required === true) {
        setNumerator(prev => prev - 1)
      }
    }
  }
  const handleChangeTxt1st = e => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, value } = e.target;
      setPersonal(prevState => ({
        ...prevState,
        [name]: { ...prevState[name], value: value }
      }))
      if (_.isEmpty(personal.CustName.value) && value !== "") {
        setNumerator(prev => prev + 1)
      } else if (!_.isEmpty(personal.CustName.value) && value === "") {  //清空
        setNumerator(prev => prev - 1)
      }
    }
  }

  const [workExp, setWorkExp] = React.useState({
    usedJob: { name: "usedJob", label: "1.曾經從事", type: "text", value: null, required: true, disabled: false },
    usedStart: { name: "usedStart", label: " ", type: "date", value: null, required: true, disableFuture: true, disabled: false },
    usedEnd: { name: "usedEnd", label: " ", type: "date", value: null, required: true, disableFuture: true, disabled: false },
    usedPeriod_Y: { name: "usedPeriod_Y", label: " ", value: null, min: 0, type: "number", endAdmt: "年", startAdmt: "共", disabled: true },
    usedPeriod_M: { name: "usedPeriod_M", label: " ", value: null, min: 0, max: 12, type: "number", endAdmt: "個月", startAdmt: " ", disabled: true },



    rightNowJob: { name: "rightNowJob", label: "2.目前從事", type: "text", value: null, required: true },
    rightNowStart: { name: "rightNowStart", label: " ", type: "date", value: null, required: true, disableFuture: true },
    rightNowEnd: { name: "rightNowEnd", label: " ", type: "date", value: null, disableFuture: true, disabled: true },
    rightNowPeriod_Y: { name: "rightNowPeriod_Y", label: " ", value: '', min: 0, type: "number", endAdmt: "年", startAdmt: "共", disabled: true },
    rightNowPeriod_M: { name: "rightNowPeriod_M", label: " ", value: '', min: 0, max: 12, type: "number", endAdmt: "個月", disabled: true },
    workhours_1: { name: "workhours_1", type: "number", value: null, min: 0, step: 0.5, max: 168, endAdmt: "小時", required: true },
    workhours_2: { name: "workhours_2", type: "number", value: null, min: 0, step: 0.5, max: 168, endAdmt: "小時", required: true },
  })
  const usedDateRangeHelperText = "起始日期不能大於截止日期";
  const usedEndRightNowStartHelperText = "曾經從事截止日期不能大於目前從事起始日期";
  const workDateRangeHelperTexts = [usedDateRangeHelperText, usedEndRightNowStartHelperText];

  const isBlankValue = value => _.isNil(value) || value === "";
  const toWorkMonthValue = value => {
    if (isBlankValue(value)) {
      return null;
    }
    const fullDate = moment(value, ["YYYY年MM月DD日", "YYYY年M月D日"], true);
    if (fullDate.isValid()) {
      return fullDate.format("YYYY年MM月");
    }
    const monthDate = moment(value, ["YYYY年MM月", "YYYY年M月"], true);
    if (monthDate.isValid()) {
      return monthDate.format("YYYY年MM月");
    }
    return null;
  }
  const toHireDateValue = value => {
    const monthValue = toWorkMonthValue(value);
    return monthValue ? `${monthValue}01日` : null;
  }
  const toWorkMonthMoment = value => {
    const monthValue = toWorkMonthValue(value);
    if (!monthValue) {
      return null;
    }
    const parsed = moment(monthValue + "01日", "YYYY年MM月DD日", true);
    return parsed.isValid() ? parsed : null;
  }
  const isUsedDateRangeInvalid = (nextWorkExp = workExp) => {
    const start = toWorkMonthMoment(nextWorkExp.usedStart.value);
    const end = toWorkMonthMoment(nextWorkExp.usedEnd.value);
    return !!start && !!end && start.isAfter(end, "month");
  }
  const isUsedEndRightNowStartInvalid = (nextWorkExp = workExp) => {
    const usedEnd = toWorkMonthMoment(nextWorkExp.usedEnd.value);
    const rightNowStart = toWorkMonthMoment(nextWorkExp.rightNowStart.value);
    return !!usedEnd && !!rightNowStart && usedEnd.isAfter(rightNowStart, "month");
  }
  const isWorkDateRangeInvalid = (nextWorkExp = workExp) => (
    isUsedDateRangeInvalid(nextWorkExp) || isUsedEndRightNowStartInvalid(nextWorkExp)
  );
  const clearUsedDateRangeError = item => (
    workDateRangeHelperTexts.includes(item.helperText) ? omit(item, ["error", "helperText"]) : item
  );
  const applyWorkDateRangeError = nextWorkExp => {
    const usedDateRangeInvalid = isUsedDateRangeInvalid(nextWorkExp);
    const usedEndRightNowStartInvalid = isUsedEndRightNowStartInvalid(nextWorkExp);
    let nextState = {
      ...nextWorkExp,
      usedStart: clearUsedDateRangeError(nextWorkExp.usedStart),
      usedEnd: clearUsedDateRangeError(nextWorkExp.usedEnd),
      rightNowStart: clearUsedDateRangeError(nextWorkExp.rightNowStart),
    };
    if (usedDateRangeInvalid) {
      nextState = {
        ...nextState,
        usedStart: { ...nextState.usedStart, error: true, helperText: usedDateRangeHelperText },
        usedEnd: { ...nextState.usedEnd, error: true, helperText: usedDateRangeHelperText },
      };
    }
    if (usedEndRightNowStartInvalid) {
      nextState = {
        ...nextState,
        usedEnd: { ...nextState.usedEnd, error: true, helperText: usedEndRightNowStartHelperText },
        rightNowStart: { ...nextState.rightNowStart, error: true, helperText: usedEndRightNowStartHelperText },
      };
    }
    return nextState;
  }
  const getWorkDateMinDate = (name, fallback) => {
    const minDates = [];
    if (name === "usedEnd") {
      minDates.push(toWorkMonthMoment(workExp.usedStart.value));
    }
    if (name === "rightNowStart") {
      minDates.push(toWorkMonthMoment(workExp.usedEnd.value));
    }
    const minDate = minDates.filter(Boolean).reduce((latest, item) => (
      !latest || item.isAfter(latest, "month") ? item : latest
    ), null);
    return minDate ? minDate.toDate() : fallback;
  }
  const getWorkDateMaxDate = (name, fallback) => {
    const maxDates = [];
    if (name === "usedStart") {
      maxDates.push(toWorkMonthMoment(workExp.usedEnd.value));
    }
    if (name === "usedEnd") {
      maxDates.push(toWorkMonthMoment(workExp.rightNowStart.value));
    }
    const maxDate = maxDates.filter(Boolean).reduce((earliest, item) => (
      !earliest || item.isBefore(earliest, "month") ? item : earliest
    ), null);
    return maxDate ? maxDate.toDate() : fallback;
  }
  const getPickerValueDate = value => {
    if (value instanceof Date) {
      return moment(value).isValid() ? moment(value) : null;
    }
    if (moment.isMoment(value)) {
      return value.isValid() ? value : null;
    }
    const parsed = moment(value, ["YYYY年MM月DD日", "YYYY年M月D日", "YYYY年MM月", "YYYY年M月"], true);
    return parsed.isValid() ? parsed : null;
  }
  const getPickerInitialFocusedDate = ({ value, minDate, maxDate, disableFuture }) => {
    const selectedDate = getPickerValueDate(value);
    if (selectedDate) {
      return selectedDate.toDate();
    }
    const min = moment(minDate || new Date("1900-01-01"));
    const max = moment(maxDate || new Date("2100-01-01"));
    let latest = max;
    if (disableFuture && moment().isBefore(latest, "day")) {
      latest = moment();
    }
    if (latest.isBefore(min, "day")) {
      return min.toDate();
    }
    return latest.toDate();
  }
  const getWorkRange = (start, end) => {
    const months = Math.max(0, end.diff(start, "months"));
    return {
      y: Math.floor(months / 12),
      m: months % 12,
    };
  }

  React.useEffect(() => {
    if (!_.isNil(imageURL)) {
      return;
    }

    const rightNowStartValue = toWorkMonthValue(personal.hireDate.value);

    const wasBlank = isBlankValue(workExp.rightNowStart.value);
    const willBlank = isBlankValue(rightNowStartValue);

    setWorkExp(prevState => {
      const nextState = {
        ...prevState,
        rightNowStart: {
          ...prevState.rightNowStart,
          value: rightNowStartValue
        }
      };

      return applyWorkDateRangeError(nextState);
    });

    if (workExp.rightNowStart.required === true) {
      if (wasBlank && !willBlank) {
        setNumerator(prev => prev + 1);
      } else if (!wasBlank && willBlank) {
        setNumerator(prev => prev - 1);
      }
    }
  }, [personal.hireDate.value]);


  const workRef = useRef(null);
  const handleChangeTxt2nd = e => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      // console.log("?!")
      const { name, value } = e.target;
      if (name === "usedJob" || name === "rightNowJob" || name === "workhours_1" || name === "workhours_2") {
        setWorkExp(prevState => ({
          ...prevState,
          [name]: { ...prevState[name], value: value }
        }))
        // console.log(workExp[name].value)

        if ((workExp[name].value === "" || workExp[name].value === null) && value !== "" && workExp[name].required === true) {
          setNumerator(prev => prev + 1)
        } else if (value === "" && workExp[name].required === true) {
          setNumerator(prev => prev - 1)
        }
      }
    }

  }
  const handleDateChange2nd = (name, e, v) => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      // console.log(name, v)
      // console.log(workExp[name].value)
      if (name === "rightNowStart") {
        const nextHireDateValue = toHireDateValue(v);
        const wasHireDateBlank = isBlankValue(personal.hireDate.value);
        const willHireDateBlank = isBlankValue(nextHireDateValue);
        setPersonal(prevState => ({
          ...prevState,
          hireDate: {
            ...prevState.hireDate,
            value: nextHireDateValue
          }
        }));
        if (personal.hireDate.required === true) {
          if (wasHireDateBlank && !willHireDateBlank) {
            setNumerator(prev => prev + 1);
          } else if (!wasHireDateBlank && willHireDateBlank) {
            setNumerator(prev => prev - 1);
          }
        }
      }
      setWorkExp(prevState => {
        const nextState = {
          ...prevState,
          [name]: { ...prevState[name], value: v }
        };
        return name === "usedStart" || name === "usedEnd" || name === "rightNowStart"
          ? applyWorkDateRangeError(nextState)
          : nextState;
      });
      if ((workExp[name].value === "" || workExp[name].value === null) && (v === "" || v === null)) {
        return
      }
      if ((workExp[name].value === "" || workExp[name].value === null) && (v !== null || v !== "") && workExp[name].required === true) {
        setNumerator(prev => prev + 1)
      } else if ((v === "" || v === null) && workExp[name].required === true) {
        setNumerator(prev => prev - 1)
      }
    }
  }
  const calculateWorkRange = () => {
    // console.log(workExp.usedStart.value)
    // console.log(workExp.usedEnd.value)
    const usedStart = toWorkMonthMoment(workExp.usedStart.value);
    const usedEnd = toWorkMonthMoment(workExp.usedEnd.value);
    if (usedStart && usedEnd && !usedStart.isAfter(usedEnd, "month")) {
      const { y, m } = getWorkRange(usedStart, usedEnd);
      setWorkExp(prevState => ({
        ...prevState,
        usedPeriod_Y: { ...prevState.usedPeriod_Y, value: y },
        usedPeriod_M: { ...prevState.usedPeriod_M, value: m }
      }))
    } else if (!usedStart || !usedEnd || isUsedDateRangeInvalid(workExp)) {
      setWorkExp(prevState => ({
        ...prevState,
        usedPeriod_Y: { ...prevState.usedPeriod_Y, value: '' },
        usedPeriod_M: { ...prevState.usedPeriod_M, value: '' }
      }))
    }
    if (!isBlankValue(workExp.rightNowPeriod_Y.value) || !isBlankValue(workExp.rightNowPeriod_M.value)) {
      setWorkExp(prevState => ({
        ...prevState,
        rightNowPeriod_Y: { ...prevState.rightNowPeriod_Y, value: '' },
        rightNowPeriod_M: { ...prevState.rightNowPeriod_M, value: '' }
      }))
    }
  }

  React.useEffect(() => {
    calculateWorkRange();
  }, [workExp.usedStart, workExp.usedEnd, workExp.rightNowEnd, workExp.rightNowStart]); //避免循環
  const useStyles = makeStyles({
    pagePaper: {
      minHeight: "100%",
      boxSizing: "border-box",
    },
    questionWrap: {
      width: "100%",
      boxSizing: "border-box",
      padding: "8px 8px calc(104px + env(safe-area-inset-bottom))",
    },
    pageTitle: {
      textAlign: "center",
      margin: "12px 0 16px",
      lineHeight: 1.25,
      fontSize: "clamp(1.35rem, 6vw, 2rem)",
    },
    submitButton: {
      width: "100%", background: '#2E3B55', fontWeight: "bold", minHeight: 48,
      "&:hover": {
        background: '#fffff',
        // color:'#2E3B55'
      }
    },
    fixedSubmitBar: {
      bottom: 0,
      left: 0,
      right: 0,
      position: "fixed",
      width: "100%",
      zIndex: 1200,
      background: "#fff",
      paddingBottom: "env(safe-area-inset-bottom)",
      boxShadow: "0 -2px 8px rgba(0,0,0,0.12)",
    },
    submitBottomSpacer: {
      height: "calc(72px + env(safe-area-inset-bottom))",
    },
    media: {
      height: 620,
      width: "100%",
      objectFit: 'cover',

    },

  });
  const { app } = useSelector(state => ({
    app: state.app,
  }));
  const classes = useStyles();
  React.useEffect(() => {
    if (initialRender.current) { //初始載入
      initialRender.current = false
      //初始若登入者有公司名稱訊息
      if (UserInfo.CustName?.length > 0) {
        setNumerator(prev => prev + 1)
      }
    }
  }, []); //避免循環
  const handleClear = () => {
    if (_.isNil(imageURL)) {
      setPersonal(prevstate => ({
        ...prevstate,
        CustName: { ...prevstate.CustName, value: "" }
      }));
      if (personal.CustName.value !== "") {
        setNumerator(prev => prev - 1)
      }
    }
  }
  //是否需要輪班
  const [shiftChk, setShiftChk] = React.useState({
    YN: { checked: false, name: "YN" },
    Yes: null,
    No: null,
  })
  //是否需要輪班，紀錄OBJ
  const [shiftChkObj, setShiftChkObj] = React.useState({
    YN: { checked: false },
    Yes: null,
    No: null,
  })
  // React.useEffect(() => {
  //   console.log(!shiftChkObj.Yes ? 'X' : shiftChkObj.Yes.toString())
  // }, [shiftChkObj])
  const handleShiftChk = e => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, checked } = e.target;
      // console.log(name, checked)
      if (name === "Yes") {
        setShiftChkObj(prev => ({
          YN: { ...prev.YN, checked: true },
          Yes: checked,
          No: !checked
        }));
        if (shiftChkObj.Yes === null) {
          setNumerator(prev => prev + 1);
        }
        if (checked === false) {
          //先移除所有checked
          const keys = Object.keys(YesShiftChkObj);
          keys.map(item => {
            delete YesShiftChkObj[item].checked;
            delete YesShiftChkObj[item].value;
          })
          setDenominator(prev => prev - 1);
        }
        else {//YES + checked
          setDenominator(prev => prev + 1);
        }
      }
      else if (name === "No") {
        setShiftChkObj(prev => ({
          YN: { ...prev.YN, checked: true },
          Yes: !checked,
          No: checked
        }))

        if (shiftChkObj.No === null) {
          setNumerator(prev => prev + 1);
        }

        if (checked === true) {
          //先移除所有checked
          const keys = Object.keys(YesShiftChkObj);
          keys.map(item => {
            delete YesShiftChkObj[item].checked;
            delete YesShiftChkObj[item].value;
          })
          if (shiftChkObj.No !== null) {
            setDenominator(prev => prev - 1);
          }
        }
        else {//YES + checked
          setDenominator(prev => prev + 1);
        }
      }
    }
  }



  const [CChkObj, setCChkObj] = React.useState({
    YN: { checked: false },
    Yes: null,
    No: null,
  })

  //忘記日期勾選
  const [forgot, setforgot] = React.useState(false)
  const handleforgotChk = e => {

    setWorkExp(prevState => ({
      ...prevState,

      usedStart: {
        ...omit(prevState.usedStart, ["error", "helperText"]),
        disabled: false,
        value: null
      },
      usedEnd: {
        ...omit(prevState.usedEnd, ["error", "helperText"]),
        disabled: false,
        value: null
      },
      usedPeriod_Y: { ...prevState.usedPeriod_Y, value: '' },
      usedPeriod_M: { ...prevState.usedPeriod_M, value: '' },
    }));

    setforgot(!forgot);

    if (NoJob) {
      setWorkExp(prevState => ({
        ...prevState,
        usedJob: {
          ...prevState.usedJob,
          disabled: false,
          value: null
        },
      }));
      setNoJob(false);
    }

    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, checked } = e.target;
      // console.log(name, checked)
      if (!forgot) {
        setWorkExp(prevState => ({
          ...prevState,
          usedStart: {
            ...omit(prevState.usedStart, ["error", "helperText"]),
            disabled: true,
            value: null
          },
          usedEnd: {
            ...omit(prevState.usedEnd, ["error", "helperText"]),
            disabled: true,
            value: null
          }
        }));
        setforgot(true)
      }
      else if (forgot) {


        setforgot(false)
      }
    }
  }

  //無工作經歷勾選
  const [NoJob, setNoJob] = React.useState(false)
  const handlenojobChk = e => {

    setWorkExp(prevState => ({
      ...prevState,
      usedJob: {
        ...prevState.usedJob,
        disabled: false,
        value: null
      },
      usedStart: {
        ...omit(prevState.usedStart, ["error", "helperText"]),
        disabled: false,
        value: null
      },
      usedEnd: {
        ...omit(prevState.usedEnd, ["error", "helperText"]),
        disabled: false,
      },
      usedPeriod_Y: { ...prevState.usedPeriod_Y, value: '' },
      usedPeriod_M: { ...prevState.usedPeriod_M, value: '' },
    }));

    setNoJob(!NoJob);
    if (forgot) {
      setforgot(false);
    }

    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, checked } = e.target;
      // console.log(name, checked)
      if (!NoJob) {
        setWorkExp(prevState => ({
          ...prevState,
          usedJob: {
            ...prevState.usedJob,
            disabled: true,
            value: '無'
          },
          usedStart: {
            ...omit(prevState.usedStart, ["error", "helperText"]),
            disabled: true,
            value: null
          },
          usedEnd: {
            ...omit(prevState.usedEnd, ["error", "helperText"]),
            disabled: true,
            value: null
          },

        }));
        setNoJob(true)
      }
      else if (NoJob) {


        setNoJob(false)
      }
    }
  }


  //輪班勾是的進階List
  const [YesShiftChk, setYesShiftChk] = React.useState({
    Shift2: { name: "Shift2", checked: null, type: "chkBox", gridWid: 2 },
    Shift3: { name: "Shift3", checked: null, type: "chkBox", gridWid: 2 },
    Shift4: { name: "Shift4", checked: null, type: "chkBox", gridWid: 2 },
    ShiftOther: { name: "ShiftOther", checked: null, value: "", gridWid: 2 }
  });
  //輪班勾是的進階List，紀錄OBJ
  const [YesShiftChkObj, setYesShiftChkObj] = React.useState({
    Shift2: { checked: null, systemLabel: "兩班制　" },
    Shift3: { checked: null, systemLabel: "三班制　" },
    Shift4: { checked: null, systemLabel: "四班制　" },
    ShiftOther: { checked: null, value: "", systemLabel: "其他：" }
  });
  const [YesShiftChkObjAll, setYesShiftChkObjAll] = React.useState({
    checked: null, name: "YesShiftChkObjAll"
  });
  React.useEffect(() => {
    if (!initialRender.current) {
      const total = Object.values(YesShiftChkObj).reduce((a, b) => a + (b.checked ? 1 : 0), 0);
      // console.log(total)
      // console.log(YesShiftChkObjAll)
      if (total >= 1) {
        setYesShiftChkObjAll(prev => ({
          ...prev, checked: true
        }))
        if (!YesShiftChkObjAll.checked || YesShiftChkObjAll.checked === null) {
          setNumerator(prev => prev + 1);
        }
      } else if (total === 0) {
        setYesShiftChkObjAll(prev => ({
          ...prev, checked: false
        }))
        if (YesShiftChkObjAll.checked) {
          setNumerator(prev => prev - 1);
        }
      }
      // let Shift = Object.values(YesShiftChkObj).reduce((a, b) => a + (b.checked ? "||" + b.systemLabel : ""), "");
      // console.log(Shift)
      // console.log("||" + (YesShiftChkObj.ShiftOther.value || ""))
    }
  }, [YesShiftChkObj])
  const handleChangeYesShift = e => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, checked } = e.target;
      //先移除所有checked
      const keys = Object.keys(YesShiftChkObj);
      keys.map(item => {
        delete YesShiftChkObj[item].checked
        delete YesShiftChkObj[item].value
      })
      //選中那個勾選
      setYesShiftChkObj(prev => ({
        ...prev,
        [name]: { ...prev[name], checked }
      }));
    }
  }

  const handleChangeYesShiftOther = e => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, value } = e.target;
      setYesShiftChkObj(prev => ({
        ...prev,
        [name]: { ...prev[name], value }
      }));
    }
  }



  const workBlockTitleStyle = {
    width: "100%",
    fontSize: 16,
    fontWeight: 700,
    color: "#b71c1c",
    margin: "8px 0 12px",
    paddingBottom: 6,
    borderBottom: "1px solid #ffcdd2",
  };

  const workSubDividerStyle = {
    width: "100%",
    height: 1,
    backgroundColor: "#e0e0e0",
    margin: "18px 0 16px",
  };

  const workRowWrapStyle = {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: "10px 18px",
    marginBottom: 8,
  };

  const workCheckWrapStyle = {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: "0 18px",
    marginTop: 6,
    marginBottom: 6,
  };

  return (
    <Paper ref={ref} className={classes.pagePaper}>
      <GridContainer>
        <GridItem className={`App ${classes.questionWrap}`} ref={ref} id={'jsx-template'} xs={12} sm={12} md={10} lg={10}>
          <h1 className={classes.pageTitle}><FormattedMessage id={"基本資料填寫"} /></h1>
          <form onSubmit={handleSubmit} ref={formRef} noValidate>
            <MuiPickersUtilsProvider utils={MomentUtils} locale={app.i18n.locale}>
              {isShown && (
                <fieldset>
                  <legend align="left" style={{ fontWeight: "bold" }} ><Typography variant="h6" style={{ fontWeight: 600 }}><FormattedMessage id={"一、基本資料："} /></Typography></legend>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={6} lg={6}>
                      <ListItem button>
                        <TextField key={0} error={personal.CustName.error || false} required id="standard-required" name={personal.CustName.name} label="1. 事業單位名稱" fullWidth
                          helperText={personal.CustName.error ? personal.CustName.helperText : null} autoComplete="off" inputProps={{ maxLength: 20 }} value={personal.CustName.value || ""}
                          onChange={handleChangeTxt1st}
                          InputProps={{
                            endAdornment: <InputAdornment position="end">
                              <IconButton onClick={handleClear}>
                                <CancelIcon />
                              </IconButton>
                            </InputAdornment>,
                          }}
                        />
                      </ListItem>
                    </GridItem>
                    {/* <GridItem xs={12} sm={4} md={4} lg={4}>
                    <FormControl required error={gender.error || false} name="gender" >
                      <FormLabel>2.性別：</FormLabel>
                      <input type="checkbox" name={"gender"} required checked={gender.male || gender.female} style={{ opacity: 0, height: "0px" }} />
                      <FormGroup style={{ display: "inline" }}>
                        <FormControlLabel
                          control={<Checkbox checked={gender.male} onChange={handleChangeChkGender} name="male" color="primary" />}
                          label="男"
                        />
                        <FormControlLabel
                          control={<Checkbox checked={gender.female} onChange={handleChangeChkGender} name="female" color="secondary" />}
                          label="女"
                        />
                      </FormGroup>
                      {gender.error ? (<FormHelperText>{gender.helperText}</FormHelperText>) : null}
                    </FormControl>
                  </GridItem> */}
                    {/* <GridItem xs={12} sm={12} md={12} lg={12}>
                    <TextField key={1} error={personal.personalID.error || false} required id="standard-required" name={"personalID"} label="3. 身分證字號(居留證及護照號碼)"
                      helperText={personal.personalID.error ? personal.personalID.helperText : null} style={{ width: 300 }} inputProps={{ minLength: 9 }} autoComplete="off"
                      value={personal.personalID.value || ""} onChange={handleChangeTxt1st}
                    />
                  </GridItem> */}
                    <GridItem xs={12} sm={6} md={4} lg={4}>
                      <ListItem button>
                        <KeyboardDatePicker
                          format="YYYY年MM月DD日"
                          key={1}
                          views={["year", "month", "date"]}
                          fullWidth
                          autoOk
                          autoComplete="off"
                          clearable
                          type="datetime"
                          inputProps={getDatePickerInputProps(personal.hireDate.name, {
                            // ...prop //像是minLength、pattern
                            pattern: "[0-9]{4}年(0[1-9]|1[012])月(0[1-9]|1[0-9]|2[0-9]|3[01])日"
                          })}
                          name={personal.hireDate.name}
                          {...getDatePickerOpenProps(personal.hireDate.name)}
                          required={personal.hireDate.required || false}
                          error={personal.hireDate.error || false}
                          helperText={
                            personal.hireDate.error ? (
                              personal.hireDate.helperText
                            ) : null}
                          todayLabel={<TodayIcon />}
                          showTodayButton
                          minDate={personal.hireDate.minDate || new Date("1900-01-01")}
                          maxDate={personal.hireDate.maxDate || new Date("2100-01-01")}
                          initialFocusedDate={getPickerInitialFocusedDate({
                            value: personal.hireDate.value,
                            minDate: personal.hireDate.minDate || new Date("1900-01-01"),
                            maxDate: personal.hireDate.maxDate || new Date("2100-01-01"),
                            disableFuture: personal.hireDate.disableFuture || false,
                          })}
                          clearLabel={"X"}
                          openTo={"year"}
                          label={personal.hireDate.label}
                          value={personal.hireDate.value}
                          inputValue={personal.hireDate.value}
                          onChange={(event, value) =>
                            handleDateChange(personal.hireDate.name, event, value)
                          }
                        />
                      </ListItem>
                    </GridItem>
                  </GridContainer>
                </fieldset>
              )}

              {/* 中間留白 */}
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <div style={{ height: 40 }}></div>
              </GridItem>

              {isShown && (
                <fieldset >
                  <legend align="left" style={{ fontWeight: "bold" }} ref={workRef}><Typography variant="h6" style={{ fontWeight: 600 }}><FormattedMessage id={"二、作業經歷："} /></Typography></legend>

                  <FormLabel
                    component="div"
                    style={{
                      display: "block",
                      width: "100%",
                      backgroundColor: "#fff5f5",
                      border: "1px solid #ffcdd2",
                      borderLeft: "5px solid #e53935",
                      borderRadius: "10px",
                      padding: "12px 14px",
                      marginTop: "8px",
                      marginBottom: "16px",
                      fontSize: "clamp(14px, 2.5vw, 16px)",
                      lineHeight: "1.7",
                      fontWeight: 500,
                      boxSizing: "border-box",
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "bold",
                        fontSize: "clamp(16px, 3vw, 18px)",
                        marginBottom: "8px",
                        color: "#b71c1c",
                      }}
                    >
                      ＊注意事項
                    </div>

                    <div style={{ marginBottom: "4px" }}>
                      <strong style={{ color: "#b71c1c" }}>曾經從事：</strong>
                      <span style={{ color: "#222" }}>
                        現任工作之前一個任職公司，起始日及截止日必須如實填寫。
                      </span>
                    </div>

                    <div style={{ marginBottom: "4px" }}>
                      <strong style={{ color: "#b71c1c" }}>目前從事：</strong>
                      <span style={{ color: "#222" }}>
                        現任工作起始日為受雇到職日，在職中則不需填截止日。
                      </span>
                    </div>

                    <div style={{ marginBottom: "4px" }}>
                      <strong style={{ color: "#b71c1c" }}>從未有工作經驗：</strong>
                      <span style={{ color: "#222" }}>
                        請選擇「無」。
                      </span>
                    </div>

                    <div>
                      <strong style={{ color: "#b71c1c" }}>工時：</strong>
                      <span style={{ color: "#222" }}>
                        以「每週」計算，例如：一天工作 8 小時，一週 5 天為 40 小時。
                      </span>
                    </div>
                  </FormLabel>

                  <GridContainer>
                    {/* 1. 曾經從事 */}

                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      <div style={workRowWrapStyle}>
                        {Object.values(workExp).slice(0, 1).map((item, key) => {
                          if (key === 0) {
                            return (
                              <FormGroup key={key}>
                                <FormControlLabel
                                  control={
                                    <TextField
                                      key={key}
                                      name={item.name}
                                      value={item.value || ""}
                                      style={{ width: 150 }}
                                      required={item.required}
                                      label=" "
                                      autoComplete="off"
                                      error={item.error || false}
                                      disabled={item.disabled || false}
                                      helperText={item.error ? <FormattedMessage id={item.helperText} /> : null}
                                      onChange={handleChangeTxt2nd}
                                    />
                                  }
                                  labelPlacement={"start"}
                                  label={<FormattedMessage id={"1.曾經從事"} />}
                                />
                              </FormGroup>
                            );
                          } else if (key === 1 || key === 2) {
                            return (
                              <React.Fragment key={key}>
                                <label>
                                  {key === 1
                                    ? intl.formatMessage({ id: "起始日期:" })
                                    : intl.formatMessage({ id: "截止日期:" })}
                                </label>
                                <KeyboardDatePicker
                                  format={(date) => moment(date).format("YYYY年MM月")}
                                  key={key}
                                  views={["year", "month"]}
                                  autoOk
                                  autoComplete="off"
                                  clearable
                                  type="datetime"
                                  inputProps={getDatePickerInputProps(item.name, {
                                    pattern: "[0-9]{4}年(0[1-9]|1[012])月",
                                  })}
                                  style={{ width: 150 }}
                                  name={item.name}
                                  {...getDatePickerOpenProps(item.name)}
                                  required={item.required || false}
                                  disableFuture={item.disableFuture || false}
                                  error={item.error || false}
                                  helperText={
                                    item.error ? <FormattedMessage id={item.helperText} /> : null
                                  }
                                  todayLabel={<TodayIcon />}
                                  showTodayButton
                                  minDate={item.minDate || new Date("1900-01-01")}
                                  maxDate={item.maxDate || new Date("2100-01-01")}
                                  initialFocusedDate={getPickerInitialFocusedDate({
                                    value: item.value,
                                    minDate: item.minDate || new Date("1900-01-01"),
                                    maxDate: item.maxDate || new Date("2100-01-01"),
                                    disableFuture: item.disableFuture || false,
                                  })}
                                  clearLabel={"X"}
                                  label={item.label}
                                  value={item.value}
                                  inputValue={item.value}
                                  onChange={(event, value) =>
                                    handleDateChange2nd(item.name, event, value)
                                  }
                                />
                              </React.Fragment>
                            );
                          } else {
                            return (
                              <TextField
                                key={key}
                                name={item.name}
                                label=" "
                                value={item.value}
                                onChange={handleChangeTxt2nd}
                                style={{ width: 120, textAlign: "center" }}
                                error={item.error || false}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <FormattedMessage id={item.endAdmt} />
                                    </InputAdornment>
                                  ),
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <FormattedMessage id={item.startAdmt || " "} />
                                    </InputAdornment>
                                  ),
                                }}
                                autoComplete="off"
                                helperText={item.error ? <FormattedMessage id={item.helperText} /> : null}
                                inputProps={{ ...item, style: { textAlign: "center" } }}
                              />
                            );
                          }
                        })}

                        {Object.values(workExp).slice(1, 5).map((item, key) => {
                          if (key === 0 || key === 1) {
                            return (
                              <FormControl key={key}>
                                <FormControlLabel
                                  label={
                                    key === 0
                                      ? intl.formatMessage({ id: "起始日期:" })
                                      : intl.formatMessage({ id: "截止日期:" })
                                  }
                                  labelPlacement={"start"}
                                  control={
                                    <KeyboardDatePicker
                                      format="YYYY年MM月"
                                      key={key}
                                      views={["year", "month"]}
                                      autoOk
                                      autoComplete="off"
                                      clearable
                                      disabled={item.disabled || false}
                                      disableFuture={item.disableFuture || false}
                                      type="datetime"
                                      inputProps={getDatePickerInputProps(item.name, {
                                        pattern: "[0-9]{4}年(0[1-9]|1[012])月",
                                      })}
                                      style={{ width: 150 }}
                                      name={item.name}
                                      {...getDatePickerOpenProps(item.name)}
                                      required={item.required || false}
                                      error={item.error || false}
                                      helperText={
                                        item.error ? <FormattedMessage id={item.helperText} /> : null
                                      }
                                      todayLabel={<TodayIcon />}
                                      showTodayButton
                                      minDate={getWorkDateMinDate(item.name, item.minDate || new Date("1900-01-01"))}
                                      maxDate={getWorkDateMaxDate(item.name, item.maxDate || new Date("2100-01-01"))}
                                      initialFocusedDate={getPickerInitialFocusedDate({
                                        value: item.value,
                                        minDate: getWorkDateMinDate(item.name, item.minDate || new Date("1900-01-01")),
                                        maxDate: getWorkDateMaxDate(item.name, item.maxDate || new Date("2100-01-01")),
                                        disableFuture: item.disableFuture || false,
                                      })}
                                      clearLabel={"X"}
                                      label={item.label}
                                      value={item.value}
                                      inputValue={item.value}
                                      onChange={(event, value) =>
                                        handleDateChange2nd(item.name, event, value)
                                      }
                                    />
                                  }
                                />
                              </FormControl>
                            );
                          } else {
                            return (
                              <FormControl key={key}>
                                <FormControlLabel
                                  labelPlacement={"start"}
                                  control={
                                    <TextField
                                      key={key}
                                      name={item.name}
                                      label=" "
                                      value={item.value}
                                      onChange={handleChangeTxt2nd}
                                      style={{ width: 120, textAlign: "center" }}
                                      error={item.error || false}
                                      disabled={item.disabled || false}
                                      InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <FormattedMessage id={item.endAdmt} />
                                          </InputAdornment>
                                        ),
                                        startAdornment: (
                                          <InputAdornment position="start">
                                            <FormattedMessage id={item.startAdmt || " "} />
                                          </InputAdornment>
                                        ),
                                      }}
                                      autoComplete="off"
                                      helperText={
                                        item.error ? <FormattedMessage id={item.helperText} /> : null
                                      }
                                      inputProps={{ ...item, style: { textAlign: "center" } }}
                                    />
                                  }
                                />
                              </FormControl>
                            );
                          }
                        })}
                      </div>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      <div style={workCheckWrapStyle}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={handleforgotChk}
                              name={"Forgot"}
                              color="primary"
                              checked={forgot}
                            />
                          }
                          label={<FormattedMessage id={"Forgot"} />}
                        />

                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={NoJob}
                              onChange={handlenojobChk}
                              name={"NoJob"}
                              color="primary"
                            />
                          }
                          label={<FormattedMessage id={"NoJob"} />}
                        />
                      </div>
                    </GridItem>

                    {/* 中間留白 */}
                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      <div style={{ height: 32 }}></div>
                    </GridItem>

                    {/* 2. 目前從事 */}


                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      <div style={workRowWrapStyle}>
                        {Object.values(workExp).slice(5, 6).map((item, key) => {
                          if (key === 0) {
                            return (
                              <FormGroup key={key}>
                                <FormControlLabel
                                  control={
                                    <TextField
                                      key={key}
                                      name={item.name}
                                      value={item.value || ""}
                                      style={{ width: 150 }}
                                      required={item.required}
                                      label=" "
                                      autoComplete="off"
                                      error={item.error || false}
                                      helperText={item.error ? <FormattedMessage id={item.helperText} /> : null}
                                      onChange={handleChangeTxt2nd}
                                    />
                                  }
                                  labelPlacement={"start"}
                                  label={<FormattedMessage id={"2.目前從事"} />}
                                />
                              </FormGroup>
                            );
                          } else if (key === 1 || key === 2) {
                            return (
                              <FormControl key={key}>
                                <FormControlLabel
                                  label={
                                    key === 0
                                      ? intl.formatMessage({ id: "起始日期:" })
                                      : intl.formatMessage({ id: "截止日期:" })
                                  }
                                  labelPlacement={"start"}
                                  control={
                                    <KeyboardDatePicker
                                      format="YYYY年MM月"
                                      key={key}
                                      views={["year", "month"]}
                                      autoOk
                                      autoComplete="off"
                                      clearable
                                      disableFuture={item.disableFuture || false}
                                      type="datetime"
                                      inputProps={getDatePickerInputProps(item.name, {
                                        pattern: "[0-9]{4}年(0[1-9]|1[012])月",
                                      })}
                                      style={{ width: 150 }}
                                      name={item.name}
                                      {...getDatePickerOpenProps(item.name)}
                                      disabled={false}
                                      required={item.required || false}
                                      error={item.error || false}
                                      helperText={
                                        item.error ? <FormattedMessage id={item.helperText} /> : null
                                      }
                                      todayLabel={<TodayIcon />}
                                      showTodayButton
                                      minDate={getWorkDateMinDate(item.name, item.minDate || new Date("1900-01-01"))}
                                      maxDate={getWorkDateMaxDate(item.name, item.maxDate || new Date("2100-01-01"))}
                                      initialFocusedDate={getPickerInitialFocusedDate({
                                        value: item.value,
                                        minDate: getWorkDateMinDate(item.name, item.minDate || new Date("1900-01-01")),
                                        maxDate: getWorkDateMaxDate(item.name, item.maxDate || new Date("2100-01-01")),
                                        disableFuture: item.disableFuture || false,
                                      })}
                                      clearLabel={"X"}
                                      label={item.label}
                                      value={item.value}
                                      inputValue={item.value}
                                      onChange={(event, value) =>
                                        handleDateChange2nd(item.name, event, value)
                                      }
                                    />
                                  }
                                />
                              </FormControl>
                            );
                          } else {
                            return (
                              <FormControl key={key}>
                                <FormControlLabel
                                  labelPlacement={"start"}
                                  control={
                                    <TextField
                                      key={key}
                                      name={item.name}
                                      label=" "
                                      value={item.value}
                                      onChange={handleChangeTxt2nd}
                                      style={{ width: 120, textAlign: "center" }}
                                      error={item.error || false}
                                      disabled={item.disabled || false}
                                      InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <FormattedMessage id={item.endAdmt} />
                                          </InputAdornment>
                                        ),
                                        startAdornment: (
                                          <InputAdornment position="start">
                                            <FormattedMessage id={item.startAdmt || " "} />
                                          </InputAdornment>
                                        ),
                                      }}
                                      autoComplete="off"
                                      helperText={
                                        item.error ? <FormattedMessage id={item.helperText} /> : null
                                      }
                                      inputProps={{ ...item, style: { textAlign: "center" } }}
                                    />
                                  }
                                />
                              </FormControl>
                            );
                          }
                        })}

                        {Object.values(workExp).slice(6, 10).map((item, key) => {
                          if (key === 0 || key === 1) {
                            return (
                              <FormControl key={key}>
                                <FormControlLabel
                                  label={
                                    key === 0
                                      ? intl.formatMessage({ id: "起始日期:" })
                                      : intl.formatMessage({ id: "截止日期:" })
                                  }
                                  labelPlacement={"start"}
                                  control={
                                    <KeyboardDatePicker
                                      format="YYYY年MM月"
                                      key={key}
                                      views={["year", "month"]}
                                      autoOk
                                      autoComplete="off"
                                      clearable
                                      disableFuture={item.disableFuture || false}
                                      disabled={item.disabled || false}
                                      type="datetime"
                                      inputProps={getDatePickerInputProps(item.name, {
                                        pattern: "[0-9]{4}年(0[1-9]|1[012])月",
                                      })}
                                      style={{ width: 150 }}
                                      name={item.name}
                                      {...getDatePickerOpenProps(item.name)}
                                      required={item.required || false}
                                      error={item.error || false}
                                      helperText={
                                        item.error ? <FormattedMessage id={item.helperText} /> : null
                                      }
                                      todayLabel={<TodayIcon />}
                                      showTodayButton
                                      minDate={getWorkDateMinDate(item.name, item.minDate || new Date("1900-01-01"))}
                                      maxDate={getWorkDateMaxDate(item.name, item.maxDate || new Date("2100-01-01"))}
                                      initialFocusedDate={getPickerInitialFocusedDate({
                                        value: item.value,
                                        minDate: getWorkDateMinDate(item.name, item.minDate || new Date("1900-01-01")),
                                        maxDate: getWorkDateMaxDate(item.name, item.maxDate || new Date("2100-01-01")),
                                        disableFuture: item.disableFuture || false,
                                      })}
                                      clearLabel={"X"}
                                      label={item.label}
                                      value={item.value}
                                      inputValue={item.value}
                                      onChange={(event, value) =>
                                        handleDateChange2nd(item.name, event, value)
                                      }
                                    />
                                  }
                                />
                              </FormControl>
                            );
                          } else {
                            return (
                              <FormControl key={key}>
                                <FormControlLabel
                                  labelPlacement={"start"}
                                  control={
                                    <TextField
                                      key={key}
                                      name={item.name}
                                      label=" "
                                      value={item.value}
                                      onChange={handleChangeTxt2nd}
                                      style={{ width: 120, textAlign: "center" }}
                                      error={item.error || false}
                                      disabled={item.disabled || false}
                                      InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            {intl.formatMessage({ id: item.endAdmt })}
                                          </InputAdornment>
                                        ),
                                        startAdornment: (
                                          <InputAdornment position="start">
                                            <FormattedMessage id={item.startAdmt || " "} />
                                          </InputAdornment>
                                        ),
                                      }}
                                      autoComplete="off"
                                      helperText={
                                        item.error ? <FormattedMessage id={item.helperText} /> : null
                                      }
                                      inputProps={{ ...item, style: { textAlign: "center" } }}
                                    />
                                  }
                                />
                              </FormControl>
                            );
                          }
                        })}
                      </div>
                    </GridItem>

                    {/* 中間留白 */}
                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      <div style={{ height: 32 }}></div>
                    </GridItem>

                    {/* 是否需要輪班 */}
                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      <div style={{ padding: "20px 0 8px" }}>
                        <FormGroup>
                          <FormControl
                            required
                            error={shiftChk.YN.error || false}
                            style={{ width: "100%" }}
                          >
                            <FormLabel>
                              <FormattedMessage id={"是否需要輪班?"} />
                            </FormLabel>
                            <input
                              type="checkbox"
                              name={shiftChk.YN.name}
                              required
                              checked={shiftChkObj.YN.checked || false}
                              style={{ opacity: 0, height: "0px" }}
                            />
                            {shiftChk.YN.error ? (
                              <FormHelperText>
                                <FormattedMessage id={shiftChk.YN.helperText} />
                              </FormHelperText>
                            ) : null}
                          </FormControl>
                        </FormGroup>
                      </div>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      <div style={workCheckWrapStyle}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={shiftChkObj.Yes || false}
                              onChange={handleShiftChk}
                              name={"Yes"}
                              color="primary"
                            />
                          }
                          label={<FormattedMessage id={"Yes"} />}
                          onMouseDown={() => {
                            shiftChkObj.Yes || false ? playActive() : playOn();
                          }}
                        />

                        <span>（</span>

                        {Object.values(YesShiftChk).map((item, key) => {
                          if (item.type === "chkBox") {
                            return (
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={YesShiftChkObj[item.name].checked || false}
                                    onChange={handleChangeYesShift}
                                    name={item.name}
                                    color="primary"
                                  />
                                }
                                disabled={!shiftChkObj.Yes || false}
                                key={key}
                                label={<FormattedMessage id={item.name} />}
                                onMouseDown={() => {
                                  YesShiftChkObj[item.name].checked || false
                                    ? playActive()
                                    : playOn();
                                }}
                              />
                            );
                          } else {
                            return (
                              <React.Fragment key={key}>
                                <Checkbox
                                  checked={YesShiftChkObj[item.name].checked || false}
                                  disabled={!shiftChkObj.Yes || false}
                                  onChange={handleChangeYesShift}
                                  name={item.name}
                                  key={key + "chk"}
                                  inputProps={{ "aria-label": "primary checkbox" }}
                                  color="primary"
                                  onMouseDown={() => {
                                    YesShiftChkObj[item.name].checked || false
                                      ? playActive()
                                      : playOn();
                                  }}
                                />
                                <TextField
                                  key={key + "txt"}
                                  disabled={!YesShiftChkObj[item.name].checked || false}
                                  required={YesShiftChkObj[item.name].checked || false}
                                  value={YesShiftChkObj[item.name].value || ""}
                                  label={<FormattedMessage id={item.name} />}
                                  name={item.name}
                                  autoComplete="off"
                                  onChange={handleChangeYesShiftOther}
                                  error={item.error || false}
                                  helperText={item.error ? <FormattedMessage id={item.helperText} /> : null}
                                />
                              </React.Fragment>
                            );
                          }
                        })}

                        <span>）</span>

                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={shiftChkObj.No || false}
                              onChange={handleShiftChk}
                              name={"No"}
                              color="primary"
                            />
                          }
                          label={<FormattedMessage id={"No"} />}
                          onMouseDown={() => {
                            shiftChkObj.No || false ? playActive() : playOn();
                          }}
                        />
                      </div>

                      <FormGroup>
                        <FormControl
                          required={shiftChkObj.Yes || false}
                          error={(shiftChkObj.Yes && YesShiftChkObjAll.error) || false}
                          style={{ width: "100%" }}
                        >
                          <FormLabel></FormLabel>
                          <input
                            type="checkbox"
                            name={"YesShiftChkObjAll"}
                            required={shiftChkObj.Yes || false}
                            checked={YesShiftChkObjAll.checked || false}
                            style={{ opacity: 0, height: "0px" }}
                          />
                          {shiftChkObj.Yes && YesShiftChkObjAll.error ? (
                            <FormHelperText>
                              <FormattedMessage id={YesShiftChkObjAll.helperText} />
                            </FormHelperText>
                          ) : null}
                        </FormControl>
                      </FormGroup>
                    </GridItem>

                    {/* 中間留白 */}
                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      <div style={{ height: 32 }}></div>
                    </GridItem>

                    {Object.values(workExp).slice(10, 11).map((item, key) => {
                      return (
                        <GridItem xs={12} sm={12} md={6} lg={6} key={key}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-start",
                              flexWrap: "wrap",
                              gap: "8px",
                              width: "100%",
                              marginBottom: 12,
                            }}
                          >
                            <span>
                              <FormattedMessage id={"過去 1 個月，"} />
                              <span style={{ textDecoration: "underline", color: "red" }}>
                                平均每週工時
                              </span>
                              <span>為:</span>
                            </span>

                            <TextField
                              required={item.required}
                              label=" "
                              error={item.error || false}
                              type={item.type}
                              style={{ width: 120 }}
                              name={item.name}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <FormattedMessage id={"小時"} />
                                  </InputAdornment>
                                ),
                              }}
                              inputProps={{
                                ...item,
                                style: { textAlign: "center" },
                              }}
                              value={item.value || ""}
                              helperText={
                                item.error ? <FormattedMessage id={item.helperText} /> : null
                              }
                              onChange={handleChangeTxt2nd}
                            />
                          </div>
                        </GridItem>
                      );
                    })}

                    {Object.values(workExp).slice(11, 12).map((item, key) => {
                      return (
                        <GridItem xs={12} sm={12} md={6} lg={6} key={key}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-start",
                              flexWrap: "wrap",
                              gap: "8px",
                              width: "100%",
                              marginBottom: 12,
                            }}
                          >
                            <span>
                              <FormattedMessage id={"過去 6 個月，"} />
                              <span style={{ textDecoration: "underline", color: "red" }}>
                                平均每週工時
                              </span>
                              <span>為:</span>
                            </span>

                            <TextField
                              required={item.required}
                              label=" "
                              error={item.error || false}
                              type={item.type}
                              style={{ width: 120 }}
                              name={item.name}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <FormattedMessage id={"小時"} />
                                  </InputAdornment>
                                ),
                              }}
                              inputProps={{
                                ...item,
                                style: { textAlign: "center" },
                              }}
                              value={item.value || ""}
                              helperText={
                                item.error ? <FormattedMessage id={item.helperText} /> : null
                              }
                              onChange={handleChangeTxt2nd}
                            />
                          </div>
                        </GridItem>
                      );
                    })}
                  </GridContainer>
                </fieldset>
              )}

              {/* 中間留白 */}
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <div style={{ height: 40 }}></div>
              </GridItem>

              {isShown && (
                <fieldset >
                  <legend align="left" style={{ fontWeight: "bold" }} ref={checked3rdRef}><Typography variant="h6" style={{ fontWeight: 600 }}><FormattedMessage id={"三、檢查時期（原因）："} /></Typography></legend>
                  <GridContainer >
                    <GridItem xs={12} sm={6} md={6} lg={6}>
                      <FormControl required error={checked3rd.error || false}>
                        <FormLabel> </FormLabel>
                        <input type="checkbox" name={"checked3rd"} required checked={checked3rd.checkA || checked3rd.checkB} style={{ opacity: 0, height: "0px" }} />
                        <FormGroup style={{ display: "inline" }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={checked3rd.checkA || false}
                                onChange={handleChangeThree}
                                name={"checkA"}
                                color="primary"
                              />
                            }
                            label={<FormattedMessage id={"新進員工"} />}
                            onMouseDown={() => { checked3rd.checkA ? playActive() : playOn(); }}
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={checked3rd.checkB || false}
                                onChange={handleChangeThree}
                                name={"checkB"}
                                color="primary"
                              />
                            }
                            label={<FormattedMessage id={"定期檢查"} />}
                            onMouseDown={() => { checked3rd.checkB ? playActive() : playOn(); }}
                          />
                        </FormGroup>
                        {checked3rd.error ? (<FormHelperText><FormattedMessage id={checked3rd.helperText} /></FormHelperText>) : null}
                      </FormControl>

                    </GridItem>

                  </GridContainer>
                </fieldset>
              )}
              {/* 中間留白 */}
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <div style={{ height: 40 }}></div>
              </GridItem>
              <fieldset style={{ marginBottom: 16, padding: 16, borderRadius: 8 }}>
                <legend
                  align="left"
                  style={{ fontWeight: "bold", padding: "0 8px" }}
                  ref={checked4rdRef}
                >


                  <Typography variant="h6" style={{ fontWeight: 600 }}>
                    <FormattedMessage id={"四、個人資料："} />
                  </Typography>
                </legend>

                <GridContainer>
                  <GridItem xs={12}>
                    <FormGroup>
                      <Grid container spacing={2}>
                        {/* 血型 */}
                        <Grid item xs={12} sm={6} md={4}>
                          <FormControl
                            fullWidth
                            required
                            error={personal.BloodType.error || false}

                            size="small"
                          >
                            <Typography variant="body1" style={{ marginBottom: 8 }}>
                              (1) 血型：
                            </Typography>
                            <Select
                              name="BloodType"
                              value={formData.BloodType}
                              onChange={handleChange}
                              error={personal.BloodType.error || false}
                              required
                              displayEmpty
                            >
                              <MenuItem value="">
                                請選擇血型
                              </MenuItem>
                              <MenuItem value="A">A</MenuItem>
                              <MenuItem value="B">B</MenuItem>
                              <MenuItem value="O">O</MenuItem>
                              <MenuItem value="AB">AB</MenuItem>
                              <MenuItem value="不確定">不確定</MenuItem>
                            </Select>
                            {personal.BloodType.error ? (
                              <FormHelperText>
                                <FormattedMessage
                                  id={personal.BloodType.helperText}
                                  key={personal.BloodType.helperText}
                                />
                              </FormHelperText>
                            ) : null}
                          </FormControl>
                        </Grid>

                        {/* 職業 */}
                        <Grid item xs={12} sm={6} md={4} ref={occupationRef}>
                          <Typography variant="body1" style={{ marginBottom: 8 }}>
                            (2) 職業 <span style={{ color: "#f44336" }}>*</span>
                          </Typography>
                          <TextField
                            name="Occupation"
                            value={formData.Occupation}
                            onChange={handleChange}
                            fullWidth
                            required

                            size="small"
                            error={personal.Occupation.error || false}
                            helperText={
                              personal.Occupation.error ? personal.Occupation.helperText : null
                            }
                          />
                        </Grid>

                        {/* 聯絡電話 */}
                        <Grid item xs={12} sm={6} md={4}>
                          <Typography variant="body1" style={{ marginBottom: 8 }}>
                            (3) 聯絡電話 <span style={{ color: "#f44336" }}>*</span>
                          </Typography>
                          <TextField
                            name="OwnPhone"
                            value={formData.OwnPhone}
                            onChange={handleChange}
                            fullWidth
                            required

                            size="small"
                            error={personal.OwnPhone.error || false}
                            helperText={
                              personal.OwnPhone.error ? personal.OwnPhone.helperText : null
                            }
                          />
                        </Grid>
                      </Grid>
                    </FormGroup>

                    <div style={{ marginTop: 32 }}>
                      <Typography
                        variant="body1"
                        component="div"
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          alignItems: "baseline",
                          columnGap: 12,
                          rowGap: 4,
                          fontWeight: 500,
                          marginBottom: 12,
                        }}
                      >
                        <span>(4) 緊急聯絡人：</span>
                        <span style={{ color: "#b71c1c", fontWeight: "bold" }}>
                          發生緊急醫療狀況時第一優先聯絡人。
                        </span>
                      </Typography>

                      <FormGroup>
                        <Grid container spacing={2}>
                          {/* 關係 */}
                          <Grid item xs={12} sm={6} md={4}>
                            <FormControl
                              required
                              fullWidth
                              error={personal.relationship.error || false}

                              size="small"
                            >
                              <Typography variant="body1" style={{ marginBottom: 8 }}>
                                關係：
                              </Typography>
                              <Select
                                name="relationship"
                                value={formData.relationship}
                                onChange={handleChange}
                                error={personal.relationship.error || false}
                                required
                                displayEmpty
                              >
                                <MenuItem value="">
                                  請選擇關係
                                </MenuItem>
                                <MenuItem value="父母">父母</MenuItem>
                                <MenuItem value="兄弟姊妹">兄弟姊妹</MenuItem>
                                <MenuItem value="配偶">配偶</MenuItem>
                                <MenuItem value="其他">其他</MenuItem>
                              </Select>

                              {personal.relationship.error ? (
                                <FormHelperText>
                                  <FormattedMessage
                                    id={personal.relationship.helperText}
                                    key={personal.relationship.helperText}
                                  />
                                </FormHelperText>
                              ) : null}
                            </FormControl>
                          </Grid>

                          {/* 其他關係 */}
                          {formData.relationship === "其他" && (
                            <Grid item xs={12} sm={6} md={4}>
                              <Typography variant="body1" style={{ marginBottom: 8 }}>
                                請輸入其他關係 <span style={{ color: "#f44336" }}>*</span>
                              </Typography>
                              <TextField
                                name="otherRelationship"
                                value={formData.otherRelationship || ""}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    otherRelationship: e.target.value,
                                  })
                                }
                                fullWidth
                                required

                                size="small"
                                error={personal.otherRelationship.error || false}
                                helperText={
                                  personal.otherRelationship.error
                                    ? personal.otherRelationship.helperText
                                    : null
                                }
                              />
                            </Grid>
                          )}

                          {/* 姓名 */}
                          <Grid item xs={12} sm={6} md={4}>
                            <Typography variant="body1" style={{ marginBottom: 8 }}>
                              姓名 <span style={{ color: "#f44336" }}>*</span>
                            </Typography>
                            <TextField
                              name="name"
                              value={formData.name}
                              onChange={handleChange}
                              fullWidth
                              required

                              size="small"
                              error={personal.name.error || false}
                              helperText={personal.name.error ? personal.name.helperText : null}
                            />
                          </Grid>

                          {/* 緊急聯絡人電話 */}
                          <Grid item xs={12} sm={6} md={4}>
                            <Typography variant="body1" style={{ marginBottom: 8 }}>
                              緊急聯絡人電話 <span style={{ color: "#f44336" }}>*</span>
                            </Typography>
                            <TextField
                              name="phonenum"
                              value={formData.phonenum}
                              onChange={handleChange}
                              fullWidth
                              required

                              size="small"
                              error={personal.phonenum.error || false}
                              helperText={
                                personal.phonenum.error ? personal.phonenum.helperText : null
                              }
                            />
                          </Grid>
                        </Grid>
                      </FormGroup>
                    </div><br /><br />

                    {formData.Gender === "女" && (
                      <div style={{ marginTop: 32 }}>
                        <Typography variant="body1" style={{ marginBottom: 16 }}>
                          5.為了提供更精準的健康分析，請協助確認您的生理現況：
                        </Typography>

                        <FormGroup>
                          <Grid container spacing={2}>
                            {/* 生理期確認 */}
                            <Grid item xs={12} ref={isMenstruatingRef}>
                              <FormControl
                                component="fieldset"
                                required
                                error={personal?.IsMenstruating?.error || false}
                                style={{
                                  width: "100%",

                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    alignItems: "center",

                                  }}
                                >
                                  <span style={{ color: "#222", fontSize: 16 }}>
                                    目前是否為生理期？
                                  </span>

                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        color="primary"
                                        checked={formData.IsMenstruating === "是"}
                                        onChange={(e) => {
                                          setFormData((prev) => ({
                                            ...prev,
                                            IsMenstruating: e.target.checked ? "是" : "",
                                          }));
                                        }}
                                      />
                                    }
                                    label="是"
                                  />

                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        color="primary"
                                        checked={formData.IsMenstruating === "否"}
                                        onChange={(e) => {
                                          setFormData((prev) => ({
                                            ...prev,
                                            IsMenstruating: e.target.checked ? "否" : "",
                                          }));
                                        }}
                                      />
                                    }
                                    label="否"
                                  />
                                </div>

                                {personal?.IsMenstruating?.error && (
                                  <FormHelperText>
                                    {personal.IsMenstruating.helperText}
                                  </FormHelperText>
                                )}
                              </FormControl>
                            </Grid>

                            {/* LMP 說明文字 */}
                            <Grid item xs={12} ref={lmpDateRef}>
                              <Typography
                                variant="body1"

                              >
                                (1).請填寫您最近一次月經的第一天日期(LMP)，若有用藥及手術等請填寫其他原因，已停經或懷孕請勾選下方選項。
                              </Typography>
                            </Grid>

                            {/* 日期 */}
                            <Grid item xs={12} md={4}>
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                  autoOk
                                  disableToolbar
                                  variant="inline"
                                  format="yyyy/MM/dd"
                                  margin="normal"
                                  label="請填寫，最近一次月經第一天 (LMP)"
                                  value={formData.LMPDate || null}
                                  onChange={(date) => {
                                    setFormData((prev) => ({
                                      ...prev,
                                      LMPDate: date ?? null,
                                      LMPFlags: {
                                        Menopause: false,
                                        Pregnant: false,
                                        PostpartumNoPeriod: false,
                                        Other: false,
                                      },
                                      LMPOtherText: "",
                                    }));
                                  }}
                                  fullWidth
                                  inputVariant="outlined"
                                  KeyboardButtonProps={{ "aria-label": "change date" }}
                                  disableFuture
                                  maxDate={new Date()}
                                  inputProps={getDatePickerInputProps("LMPDate")}
                                  {...getDatePickerOpenProps("LMPDate")}
                                  error={personal?.LMPDate?.error || false}
                                  helperText={
                                    personal?.LMPDate?.error
                                      ? personal?.LMPDate?.helperText
                                      : null
                                  }
                                />
                              </MuiPickersUtilsProvider>
                            </Grid>

                            {/* 選項 */}
                            <Grid item xs={12} md={8}>
                              <FormControl
                                component="fieldset"
                                fullWidth
                                error={personal?.LMPFlags?.error || false}
                                style={{ marginTop: 16 }}
                              >
                                <FormGroup row>
                                  {[
                                    { key: "Menopause", label: "停經 (Menopause)" },
                                    { key: "Pregnant", label: "懷孕中 (Pregnant)" },
                                    { key: "PostpartumNoPeriod", label: "產後/哺乳中目前無月經" },
                                    { key: "Other", label: "其他" },
                                  ].map((item) => (
                                    <FormControlLabel
                                      key={item.key}
                                      style={{ marginRight: 16 }}
                                      control={
                                        <Checkbox
                                          color="primary"
                                          checked={!!formData.LMPFlags?.[item.key]}
                                          onChange={(e) => {
                                            const checked = e.target.checked;

                                            setFormData((prev) => ({
                                              ...prev,
                                              LMPFlags: {
                                                Menopause: false,
                                                Pregnant: false,
                                                PostpartumNoPeriod: false,
                                                Other: false,
                                                [item.key]: checked,
                                              },
                                              LMPDate: checked ? null : prev.LMPDate,
                                              LMPOtherText:
                                                item.key === "Other" && checked
                                                  ? prev.LMPOtherText
                                                  : "",
                                            }));
                                          }}
                                        />
                                      }
                                      label={item.label}
                                    />
                                  ))}
                                </FormGroup>

                                {formData.LMPFlags?.Other && (
                                  <div ref={lmpOtherRef}>
                                    <TextField
                                      style={{ marginTop: 8 }}
                                      label="請輸入其他狀況"
                                      value={formData.LMPOtherText || ""}
                                      onChange={(e, v) => {
                                        const next = e?.target?.value ?? v ?? "";
                                        setFormData((prev) => ({
                                          ...prev,
                                          LMPOtherText: next,
                                        }));
                                      }}
                                      fullWidth
                                      required
                                      variant="outlined"
                                      size="small"
                                      error={personal?.LMPOtherText?.error || false}
                                      helperText={
                                        personal?.LMPOtherText?.error
                                          ? personal?.LMPOtherText?.helperText
                                          : ""
                                      }
                                    />
                                  </div>
                                )}

                                {personal?.LMPFlags?.error && (
                                  <FormHelperText>
                                    {personal.LMPFlags.helperText}
                                  </FormHelperText>
                                )}
                              </FormControl>
                            </Grid>
                          </Grid>
                        </FormGroup>
                      </div>
                    )}
                  </GridItem>
                </GridContainer>
              </fieldset>

              {/* 中間留白 */}
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <div style={{ height: 40 }}></div>
              </GridItem>

              <fieldset >
                <legend align="left" style={{ fontWeight: "bold" }}>
                  <Typography variant="h6" style={{ fontWeight: 600 }}>
                    <FormattedMessage
                      id={"五、本人過去病史(非家族病史)："}
                      defaultMessage={"五、<history>本人過去病史</history>(非家族病史)："}
                      values={{
                        history: (text) => <span style={{ color: "red" }}>{text}</span>,
                      }}
                    />
                  </Typography>
                </legend>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <FormGroup ref={pastHistoryRef}>
                      <FormControl required error={array4thValidator.pastHistory.error || false} style={{ width: "100%" }}>
                        <FormLabel><FormattedMessage id={"您是否曾患有下列慢性疾病：（請在適當項目前打勾）"} /></FormLabel>
                        <input type="checkbox" name={array4thValidator.pastHistory.name} required checked={array4thValidator.pastHistory.checked || false} style={{ opacity: 0, height: "0px" }} />
                        {array4thValidator.pastHistory.error ? (<FormHelperText><FormattedMessage id={array4thValidator.pastHistory.helperText} /></FormHelperText>) : null}
                      </FormControl>
                    </FormGroup>
                  </GridItem>
                  {Object.values(array4th).map((item, key) => {
                    //console.log(item);
                    if (item.type === "chkBox") {
                      return (
                        <GridItem xs={12} sm={6} md={item.gridWid} lg={item.gridWid}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={item.checked || false}
                                onChange={handleChange4th}
                                name={item.name}
                                color="primary"
                              />
                            }
                            label={<FormattedMessage id={item.label} />}
                            onMouseDown={() => { item.checked || false ? playActive() : playOn(); }}
                          />
                        </GridItem>)
                    } else {
                      return (
                        <GridItem xs={12} sm={item.gridWid} md={item.gridWid} lg={item.gridWid}>
                          <ListItem style={{ marginLeft: "-11px", paddingLeft: "0px" }}>
                            <Checkbox
                              checked={item.checked || false}
                              onChange={handleChange4th}
                              name={item.name}
                              key={key + 'chk'}
                              inputProps={{ "aria-label": "primary checkbox" }}
                              color="primary"
                              onMouseDown={() => { item.checked || false ? playActive() : playOn(); }}
                            />
                            <TextField
                              fullWidth
                              key={key + 'txt'}
                              error={item.error || false}
                              disabled={!item.checked || false}
                              required={item.checked || false}
                              value={array4thTxtObj[item.name].text || ""}
                              label={<FormattedMessage id={item.label} />}
                              name={item.name}
                              autoComplete="off"
                              onChange={handleChangeTxt4th}
                              // inputProps={{
                              //   type2:item.type
                              // }}
                              helperText={item.error ? <FormattedMessage id={item.helperText} /> : null}
                            />
                          </ListItem>
                        </GridItem>)
                    }

                  })}
                </GridContainer>
              </fieldset>


              {/* 中間留白 */}
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <div style={{ height: 40 }}></div>
              </GridItem>

              <fieldset >
                <legend align="left" style={{ fontWeight: "bold" }}><Typography variant="h6" style={{ fontWeight: 600 }}><FormattedMessage id={"六、生活習慣："} /></Typography></legend>



                <>
                  {/* 吸菸 */}
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      <FormGroup ref={sleepRef["smoke"]}>
                        <FormControl
                          required
                          error={array5thCheck.smoke.error || false}
                          style={{ width: "100%" }}
                        >
                          <FormLabel>
                            <FormattedMessage id={"1.請問您過去一個月內是否有吸菸？"} />
                          </FormLabel>
                          <input
                            type="checkbox"
                            name={array5thCheck.smoke.name}
                            required
                            checked={array5thCheck.smoke.checked || false}
                            style={{ opacity: 0, height: "0px" }}
                          />
                          {array5thCheck.smoke.error ? (
                            <FormHelperText>
                              <FormattedMessage id={array5thCheck.smoke.helperText} />
                            </FormHelperText>
                          ) : null}
                        </FormControl>
                      </FormGroup>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      <div style={habitGridStyle}>
                        {Object.values(array5_1).map((item, key) => {
                          if (item.type === "chkBox") {
                            return (
                              <div key={key} style={habitCardStyle}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={item.checked || false}
                                      onChange={handleChangeChk5_1}
                                      name={item.name}
                                      color="primary"
                                    />
                                  }
                                  label={<FormattedMessage id={item.label} />}
                                  onMouseDown={() => {
                                    item.checked || false ? playActive() : playOn();
                                  }}
                                />
                              </div>
                            );
                          }

                          return (
                            <div key={key} style={habitCardStyle}>
                              <FormGroup>
                                <FormControlLabel
                                  style={habitCheckStyle}
                                  control={
                                    <Checkbox
                                      checked={item.checked || false}
                                      onChange={handleChangeChk5_1}
                                      name={item.name}
                                      inputProps={{ "aria-label": "primary checkbox" }}
                                      color="primary"
                                    />
                                  }
                                  label={<FormattedMessage id={item.label} />}
                                  onMouseDown={() => {
                                    item.checked || false ? playActive() : playOn();
                                  }}
                                />
                              </FormGroup>

                              <TextField
                                disabled={!item.checked || false}
                                required={item.checked || false}
                                error={array5thCheck[item.name_1].error || false}
                                value={array5thCheck[item.name_1].value || ""}
                                label={<FormattedMessage id={item.label_1} />}
                                name={item.name_1}
                                type={item.type_1}
                                style={habitFieldStyle}
                                autoComplete="off"
                                onChange={handleChangeTxt5_1}
                                helperText={
                                  array5thCheck[item.name_1].error ? (
                                    <FormattedMessage id={array5thCheck[item.name_1].helperText} />
                                  ) : null
                                }
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <FormattedMessage id={item.suffix1} />
                                    </InputAdornment>
                                  ),
                                }}
                                inputProps={{
                                  min: item.min_1,
                                  step: 1,
                                  style: { textAlign: "center" },
                                  max: item.max_1 || null,
                                }}
                              />

                              {item.label_2 ? (
                                <TextField
                                  disabled={!item.checked || false}
                                  required={item.checked || false}
                                  error={array5thCheck[item.name_2].error || false}
                                  value={array5thCheck[item.name_2].value || ""}
                                  label={<FormattedMessage id={item.label_2} />}
                                  name={item.name_2}
                                  type={item.type_2}
                                  style={habitFieldStyle}
                                  autoComplete="off"
                                  onChange={handleChangeTxt5_1}
                                  helperText={
                                    array5thCheck[item.name_2].error ? (
                                      <FormattedMessage id={array5thCheck[item.name_2].helperText} />
                                    ) : null
                                  }
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <FormattedMessage id={item.suffix2} />
                                      </InputAdornment>
                                    ),
                                  }}
                                  inputProps={{
                                    min: 0,
                                    step: 1,
                                    style: { textAlign: "center" },
                                    max: item.max_2 || null,
                                  }}
                                />
                              ) : null}
                            </div>
                          );
                        })}
                      </div>
                    </GridItem>
                  </GridContainer>
                  <br /> <br />
                  {/* 檳榔 */}
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      <FormGroup ref={sleepRef["betel"]}>
                        <FormControl
                          required
                          error={array5thCheck.betel.error || false}
                          style={{ width: "100%" }}
                        >
                          <FormLabel>
                            <FormattedMessage id={"2.請問您最近六個月內是否有嚼食檳榔？"} />
                          </FormLabel>
                          <input
                            type="checkbox"
                            name={array5thCheck.betel.name}
                            required
                            checked={array5thCheck.betel.checked || false}
                            style={{ opacity: 0, height: "0px" }}
                          />
                          {array5thCheck.betel.error ? (
                            <FormHelperText>
                              <FormattedMessage id={array5thCheck.betel.helperText} />
                            </FormHelperText>
                          ) : null}
                        </FormControl>
                      </FormGroup>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      <div style={habitGridStyle}>
                        {Object.values(array5_2).map((item, key) => {
                          if (item.type === "chkBox") {
                            return (
                              <div key={key} style={habitCardStyle}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={item.checked || false}
                                      onChange={handleChangeChk5_2}
                                      name={item.name}
                                      color="primary"
                                    />
                                  }
                                  label={<FormattedMessage id={item.label} />}
                                  onMouseDown={() => {
                                    item.checked || false ? playActive() : playOn();
                                  }}
                                />
                              </div>
                            );
                          }

                          return (
                            <div key={key} style={habitCardStyle}>
                              <FormGroup>
                                <FormControlLabel
                                  style={habitCheckStyle}
                                  control={
                                    <Checkbox
                                      checked={item.checked || false}
                                      onChange={handleChangeChk5_2}
                                      name={item.name}
                                      inputProps={{ "aria-label": "primary checkbox" }}
                                      color="primary"
                                    />
                                  }
                                  label={<FormattedMessage id={item.label} />}
                                  onMouseDown={() => {
                                    item.checked || false ? playActive() : playOn();
                                  }}
                                />
                              </FormGroup>

                              <TextField
                                disabled={!item.checked || false}
                                required={item.checked || false}
                                value={array5thCheck[item.name_1].value || ""}
                                label={<FormattedMessage id={item.label_1} />}
                                name={item.name_1}
                                type={item.type_1}
                                style={habitFieldStyle}
                                autoComplete="off"
                                onChange={handleChangeTxt5_1}
                                error={array5thCheck[item.name_1].error || false}
                                helperText={
                                  array5thCheck[item.name_1].error ? (
                                    <FormattedMessage id={array5thCheck[item.name_1].helperText} />
                                  ) : null
                                }
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <FormattedMessage id={item.suffix1} />
                                    </InputAdornment>
                                  ),
                                }}
                                inputProps={{
                                  min: 0,
                                  step: 1,
                                  style: { textAlign: "center" },
                                  max: item.max_1 || null,
                                }}
                              />

                              {item.label_2 ? (
                                <TextField
                                  disabled={!item.checked || false}
                                  required={item.checked || false}
                                  value={array5thCheck[item.name_2].value || ""}
                                  label={<FormattedMessage id={item.label_2} />}
                                  name={item.name_2}
                                  type={item.type_2}
                                  style={habitFieldStyle}
                                  autoComplete="off"
                                  onChange={handleChangeTxt5_1}
                                  error={array5thCheck[item.name_2].error || false}
                                  helperText={
                                    array5thCheck[item.name_2].error ? (
                                      <FormattedMessage id={array5thCheck[item.name_2].helperText} />
                                    ) : null
                                  }
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <FormattedMessage id={item.suffix2} />
                                      </InputAdornment>
                                    ),
                                  }}
                                  inputProps={{
                                    min: 0,
                                    step: 1,
                                    style: { textAlign: "center" },
                                    max: item.max_2 || null,
                                  }}
                                />
                              ) : null}
                            </div>
                          );
                        })}
                      </div>
                    </GridItem>
                  </GridContainer>
                  <br /> <br />
                  {/* 喝酒 */}
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      <FormGroup ref={sleepRef["drunk"]}>
                        <FormControl
                          required
                          error={array5thCheck.drunk.error || false}
                          style={{ width: "100%" }}
                        >
                          <FormLabel>
                            <FormattedMessage id={"3.請問您過去一個月內是否有喝酒？"} />
                          </FormLabel>
                          <input
                            type="checkbox"
                            name={array5thCheck.drunk.name}
                            required
                            checked={array5thCheck.drunk.checked || false}
                            style={{ opacity: 0, height: "0px" }}
                          />
                          {array5thCheck.drunk.error ? (
                            <FormHelperText>
                              <FormattedMessage id={array5thCheck.drunk.helperText} />
                            </FormHelperText>
                          ) : null}
                        </FormControl>
                      </FormGroup>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      <div style={habitGridStyle}>
                        {Object.values(array5_3).map((item, key) => {
                          if (item.type === "chkBox") {
                            return (
                              <div key={key} style={habitCardStyle}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={item.checked || false}
                                      onChange={handleChangeChk5_3}
                                      name={item.name}
                                      color="primary"
                                    />
                                  }
                                  label={<FormattedMessage id={item.label} />}
                                  onMouseDown={() => {
                                    item.checked || false ? playActive() : playOn();
                                  }}
                                />
                              </div>
                            );
                          }

                          return (
                            <div key={key} style={habitCardStyle}>
                              <FormGroup>
                                <FormControlLabel
                                  style={habitCheckStyle}
                                  control={
                                    <Checkbox
                                      checked={item.checked || false}
                                      onChange={handleChangeChk5_3}
                                      name={item.name}
                                      inputProps={{ "aria-label": "primary checkbox" }}
                                      color="primary"
                                    />
                                  }
                                  label={<FormattedMessage id={item.label} />}
                                  onMouseDown={() => {
                                    item.checked || false ? playActive() : playOn();
                                  }}
                                />
                              </FormGroup>

                              <TextField
                                disabled={!item.checked || false}
                                required={item.checked || false}
                                value={array5thCheck[item.name_1].value || ""}
                                label={<FormattedMessage id={item.label_1} />}
                                name={item.name_1}
                                type={item.type_1}
                                style={habitFieldStyle}
                                autoComplete="off"
                                onChange={handleChangeTxt5_1}
                                error={array5thCheck[item.name_1].error || false}
                                helperText={
                                  array5thCheck[item.name_1].error ? (
                                    <FormattedMessage id={array5thCheck[item.name_1].helperText} />
                                  ) : null
                                }
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <FormattedMessage id={item.suffix1} />
                                    </InputAdornment>
                                  ),
                                }}
                                inputProps={{
                                  min: 0,
                                  style: { textAlign: "center" },
                                  max: item.max_1 || null,
                                }}
                              />

                              {item.label_2 ? (
                                <TextField
                                  disabled={!item.checked || false}
                                  required={item.checked || false}
                                  value={array5thCheck[item.name_2].value || ""}
                                  label={<FormattedMessage id={item.label_2} />}
                                  name={item.name_2}
                                  type={item.type_2}
                                  style={habitFieldStyle}
                                  autoComplete="off"
                                  onChange={handleChangeTxt5_1}
                                  error={array5thCheck[item.name_2].error || false}
                                  helperText={
                                    array5thCheck[item.name_2].error ? (
                                      <FormattedMessage id={array5thCheck[item.name_2].helperText} />
                                    ) : null
                                  }
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <FormattedMessage id={item.suffix2} />
                                      </InputAdornment>
                                    ),
                                  }}
                                  inputProps={{
                                    style: { textAlign: "center" },
                                    min: 0,
                                    max: item.max_2 || null,
                                  }}
                                />
                              ) : null}

                              {item.label_3 ? (
                                <TextField
                                  disabled={!item.checked || false}
                                  required={item.checked || false}
                                  value={array5thCheck[item.name_3].value || ""}
                                  label={<FormattedMessage id={item.label_3} />}
                                  name={item.name_3}
                                  type={item.type_3}
                                  style={habitFieldStyle}
                                  autoComplete="off"
                                  onChange={handleChangeTxt5_1}
                                  error={array5thCheck[item.name_3].error || false}
                                  helperText={
                                    array5thCheck[item.name_3].error ? (
                                      <FormattedMessage id={array5thCheck[item.name_3].helperText} />
                                    ) : null
                                  }
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <FormattedMessage id={item.suffix3} />
                                      </InputAdornment>
                                    ),
                                  }}
                                  inputProps={{
                                    min: 0.1,
                                    step: 0.1,
                                    style: { textAlign: "center" },
                                    max: item.max_3 || null,
                                  }}
                                />
                              ) : null}
                            </div>
                          );
                        })}
                      </div>
                    </GridItem>
                  </GridContainer>
                </>

                <br /><br /><br />
                <div style={{ display: "flex", alignItems: "center" }} ref={sleepRef["sleep"]}>

                  {/* <label><FormattedMessage id={"4.請問您於工作日期間，平均每天睡眠時間為："} /></label>
                  <TextField
                    required
                    error={array5thCheck.sleep.error || false}
                    label=""
                    type="number"
                    name={array5thCheck.sleep.name}
                    value={array5thCheck.sleep.value}
                    onChange={handleChangeTxt5_4}
                    inputProps={{ min: 0, step: 0.5, max: 24, style: { textAlign: "center" } }}
                    InputProps={{
                      endAdornment: <InputAdornment position="end"><FormattedMessage id={"小時"} /></InputAdornment>,
                    }}
                    helperText={array5thCheck.sleep.error ? <FormattedMessage id={array5thCheck.sleep.helperText} /> : null}
                  /> */}
                  <FormControl
                    fullWidth
                    required={true}
                    key={"4"}
                    error={array5thCheck.sleep.error || false}
                  >
                    <InputLabel
                      style={{ disableAnimation: false, fontSize: '1.3rem' }}
                      disableAnimation={false}
                      shrink
                    >
                      <FormattedMessage id={"4.請問您於工作日期間，平均每天睡眠時間為："} key={"4.請問您於工作日期間，平均每天睡眠時間為："} />
                    </InputLabel><br /><br />
                    <Select
                      value={array5thCheck.sleep.value || ""}
                      // label={prop.name}
                      // disabled={prop.disabled || false}
                      key={4}
                      name={array5thCheck.sleep.name}
                      // fullWidth
                      onChange={handleChangeTxt5_4}
                      // inputProps={{ readOnly: prop.readOnly || false }}
                      displayEmpty
                      style={{
                        width: "50%",
                        maxWidth: "50%",
                        minWidth: 120,
                        boxSizing: "border-box",
                      }}
                    >
                      <MenuItem disabled value="">
                        <FormattedMessage id="app.pleaseSelect" key="app.pleaseSelect" />
                      </MenuItem>
                      {Array.from({ length: 24 }, (_, index) => {
                        const hour = index + 1;
                        return (
                          <MenuItem value={`${hour}`} key={hour}>
                            {hour} hr
                          </MenuItem>
                        )
                      })}

                    </Select>
                    {array5thCheck.sleep.error ? (
                      <FormHelperText><FormattedMessage id={array5thCheck.sleep.helperText} key={array5thCheck.sleep.helperText} /></FormHelperText>
                    ) : null
                    }
                  </FormControl>
                </div><br /><br />
              </fieldset>


              {/* 中間留白 */}
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <div style={{ height: 40 }}></div>
              </GridItem>

              <fieldset  >
                <legend align="left" style={{ fontWeight: "bold" }}><Typography variant="h6" style={{ fontWeight: 600 }}><FormattedMessage id={"七、自覺症狀："} /></Typography></legend>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <FormGroup ref={consciousRef}>
                      <FormControl required error={array4thValidator.conscious.error || false} style={{ width: "100%" }}>
                        <FormLabel><FormattedMessage id={"您最近三個月是否常有下列症狀：（請在適當項目前打勾）"} /></FormLabel>
                        <input type="checkbox" name={array4thValidator.conscious.name} required checked={array4thValidator.conscious.checked || false} style={{ opacity: 0, height: "0px" }} />
                        {array4thValidator.conscious.error ? (<FormHelperText><FormattedMessage id={array4thValidator.conscious.helperText} /></FormHelperText>) : null}
                      </FormControl>
                    </FormGroup>
                  </GridItem>
                  {Object.values(array6th).map((item, key) => {
                    //console.log(item);
                    if (item.type === "chkBox") {
                      return (
                        <GridItem xs={12} sm={item.gridWid} md={item.gridWid} lg={item.gridWid}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={item.checked || false}
                                onChange={handleChange6th}
                                name={item.name}
                                color="primary"
                              />
                            }
                            label={<FormattedMessage id={item.label} />}
                            onMouseDown={() => { item.checked || false ? playActive() : playOn(); }}
                          />
                        </GridItem>)
                    } else {
                      return (
                        <GridItem xs={12} sm={item.gridWid} md={item.gridWid} lg={item.gridWid}>
                          <ListItem style={{ marginLeft: "-11px", paddingLeft: "0px" }} ref={w6Ref}>
                            <Checkbox
                              checked={item.checked || false}
                              onChange={handleChange6th}
                              name={item.name}
                              key={key + 'chk'}
                              inputProps={{ "aria-label": "primary checkbox" }}
                              color="primary"
                              onMouseDown={() => { item.checked || false ? playActive() : playOn(); }}
                            />
                            <TextField
                              fullWidth
                              key={key + 'txt'}
                              disabled={!item.checked || false}
                              required={item.checked || false}
                              value={array4thTxtObj[item.name].text || ""}
                              label={<FormattedMessage id={item.label} />}
                              name={item.name}
                              autoComplete="off"
                              onChange={handleChangeTxt4th}
                              error={item.error || false}
                              helperText={item.error ? <FormattedMessage id={item.helperText} /> : null}
                            />
                          </ListItem>
                        </GridItem>)
                    }

                  })}
                </GridContainer>
              </fieldset>


              {/* 中間留白 */}
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <div style={{ height: 40 }}></div>
              </GridItem>

              <fieldset >
                <legend align="left" style={{ fontWeight: "bold" }}><Typography variant="h6" style={{ fontWeight: 600 }}><FormattedMessage id={"八、過敏史："} /></Typography></legend>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <FormGroup ref={allergyRef}>
                      <FormControl required error={array4thValidator.allergy.error || false} style={{ width: "100%" }}>
                        <FormLabel><FormattedMessage id={"非藥物過敏史：（請在適當項目前打勾）"} /></FormLabel>
                        <input type="checkbox" name={array4thValidator.allergy.name} required checked={array4thValidator.allergy.checked || false} style={{ opacity: 0, height: "0px" }} />
                        {array4thValidator.allergy.error ? (<FormHelperText><FormattedMessage id={array4thValidator.allergy.helperText} /></FormHelperText>) : null}
                      </FormControl>
                    </FormGroup>
                  </GridItem>
                  {Object.values(array60th).map((item, key) => {
                    //console.log(item);
                    if (item.type === "chkBox") {
                      return (
                        <GridItem xs={12} sm={6} md={item.gridWid} lg={item.gridWid}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={item.checked || false}
                                onChange={handleChange60th}
                                name={item.name}
                                color="primary"
                              />
                            }
                            label={<FormattedMessage id={item.label} />}
                            onMouseDown={() => { item.checked || false ? playActive() : playOn(); }}
                          />
                        </GridItem>)
                    } else {
                      return (
                        <GridItem xs={12} sm={item.gridWid} md={item.gridWid} lg={item.gridWid}>
                          <ListItem style={{ marginLeft: "-11px", paddingLeft: "0px" }}>
                            <Checkbox
                              checked={item.checked || false}
                              onChange={handleChange60th}
                              name={item.name}
                              key={key + 'chk'}
                              inputProps={{ "aria-label": "primary checkbox" }}
                              color="primary"
                              onMouseDown={() => { item.checked || false ? playActive() : playOn(); }}
                            />
                            <TextField
                              fullWidth
                              key={key + 'txt'}
                              error={item.error || false}
                              disabled={!item.checked || false}
                              required={item.checked || false}
                              value={array60thTxtObj[item.name].text || ""}
                              label={<FormattedMessage id={item.label} />}
                              name={item.name}
                              autoComplete="off"
                              onChange={handleChangeTxt60th}
                              // inputProps={{
                              //   type2:item.type
                              // }}
                              helperText={item.error ? <FormattedMessage id={item.helperText} /> : null}
                            />
                          </ListItem>
                        </GridItem>)
                    }

                  })}
                </GridContainer>
              </fieldset>


              {/* 中間留白 */}
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <div style={{ height: 40 }}></div>
              </GridItem>

              <fieldset >
                <legend align="left" style={{ fontWeight: "bold" }}><Typography variant="h6" style={{ fontWeight: 600 }}><FormattedMessage id={"九、藥物過敏史"} /></Typography></legend>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <FormGroup ref={drug_allergyRef}>
                      <FormControl required error={array4thValidator.drug_allergy.error || false} style={{ width: "100%" }}>
                        <FormLabel><FormattedMessage id={"藥物過敏史：（請在適當項目前打勾）"} /></FormLabel>
                        <input type="checkbox" name={array4thValidator.drug_allergy.name} required checked={array4thValidator.drug_allergy.checked || false} style={{ opacity: 0, height: "0px" }} />
                        {array4thValidator.drug_allergy.error ? (<FormHelperText><FormattedMessage id={array4thValidator.drug_allergy.helperText} /></FormHelperText>) : null}
                      </FormControl>
                    </FormGroup>
                  </GridItem>
                  {Object.values(array60th_drug).map((item, key) => {

                    if (item.type === "chkBox") {
                      // console.log(444);
                      return (
                        <GridItem xs={12} sm={6} md={item.gridWid} lg={item.gridWid}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={item.checked || false}
                                onChange={handleChange60th_drug}
                                name={item.name}
                                color="primary"
                              />
                            }
                            label={<FormattedMessage id={item.label} />}
                            onMouseDown={() => { item.checked || false ? playActive() : playOn(); }}
                          />
                        </GridItem>)
                    } else {
                      //  console.log(555);
                      return (
                        <GridItem xs={12} sm={item.gridWid} md={item.gridWid} lg={item.gridWid}>
                          <ListItem style={{ marginLeft: "-11px", paddingLeft: "0px" }}>
                            <Checkbox
                              checked={item.checked || false}
                              onChange={handleChange60th_drug}
                              name={item.name}
                              key={key + 'chk'}
                              inputProps={{ "aria-label": "primary checkbox" }}
                              color="primary"
                              onMouseDown={() => { item.checked || false ? playActive() : playOn(); }}
                            />
                            <TextField
                              fullWidth
                              key={key + 'txt'}
                              error={item.error || false}
                              disabled={!item.checked || false}
                              required={item.checked || false}
                              value={array60th_drugTxtObj[item.name].text || ""}
                              label={<FormattedMessage id={item.label} />}
                              name={item.name}
                              autoComplete="off"
                              onChange={handleChangeTxt60th_drug}
                              // inputProps={{
                              //   type2:item.type
                              // }}
                              helperText={item.error ? <FormattedMessage id={item.helperText} /> : null}
                            />
                          </ListItem>
                        </GridItem>)
                    }

                  })}
                </GridContainer>
              </fieldset>


              {/* 中間留白 */}
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <div style={{ height: 40 }}></div>
              </GridItem>

              <fieldset >
                <legend align="left" style={{ fontWeight: "bold" }}><Typography variant="h6" style={{ fontWeight: 600 }}><FormattedMessage id={"十、用藥史："} /></Typography></legend>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <FormGroup ref={usageRef}>
                      <FormControl required error={array4thValidator.usage.error || false} style={{ width: "100%" }}>
                        <FormLabel><FormattedMessage id={"用藥史：（請在適當項目前打勾）"} /></FormLabel>
                        <input type="checkbox" name={array4thValidator.usage.name} required checked={array4thValidator.usage.checked || false} style={{ opacity: 0, height: "0px" }} />
                        {array4thValidator.usage.error ? (<FormHelperText><FormattedMessage id={array4thValidator.usage.helperText} /></FormHelperText>) : null}
                      </FormControl>
                    </FormGroup>
                  </GridItem>
                  {Object.values(array7th).map((item, key) => {
                    //console.log(item);
                    if (item.type === "chkBox") {
                      return (
                        <GridItem xs={12} sm={6} md={item.gridWid} lg={item.gridWid}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={item.checked || false}
                                onChange={handleChange7th}
                                name={item.name}
                                color="primary"
                              />
                            }
                            label={<FormattedMessage id={item.label} />}
                            onMouseDown={() => { item.checked || false ? playActive() : playOn(); }}
                          />
                        </GridItem>)
                    } else {
                      return (
                        <GridItem xs={12} sm={item.gridWid} md={item.gridWid} lg={item.gridWid}>
                          <ListItem style={{ marginLeft: "-11px", paddingLeft: "0px" }}>
                            <Checkbox
                              checked={item.checked || false}
                              onChange={handleChange7th}
                              name={item.name}
                              key={key + 'chk'}
                              inputProps={{ "aria-label": "primary checkbox" }}
                              color="primary"
                              onMouseDown={() => { item.checked || false ? playActive() : playOn(); }}
                            />
                            <TextField
                              fullWidth
                              key={key + 'txt'}
                              error={item.error || false}
                              disabled={!item.checked || false}
                              required={item.checked || false}
                              value={array7thTxtObj[item.name].text || ""}
                              label={<FormattedMessage id={item.label} />}
                              name={item.name}
                              autoComplete="off"
                              onChange={handleChangeTxt7th}
                              // inputProps={{
                              //   type2:item.type
                              // }}
                              helperText={item.error ? <FormattedMessage id={item.helperText} /> : null}
                            />
                          </ListItem>
                        </GridItem>)
                    }

                  })}
                </GridContainer>
              </fieldset>


              {/* 中間留白 */}
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <div style={{ height: 40 }}></div>
              </GridItem>

              <fieldset style={{ marginBottom: "90px" }}>
                <legend align="left" style={{ fontWeight: "bold" }}><Typography variant="h6" style={{ fontWeight: 600 }}><FormattedMessage id={"十一、家族病史："} /></Typography></legend>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <FormGroup ref={familyRef}>
                      <FormControl required error={array4thValidator.family.error || false} style={{ width: "100%" }}>
                        <FormLabel><FormattedMessage id={"請問您的父母是否曾患有下列慢性疾病：（請在適當項目前打勾）"} /></FormLabel>
                        <input type="checkbox" name={array4thValidator.family.name} required checked={array4thValidator.family.checked || false} style={{ opacity: 0, height: "0px" }} />
                        {array4thValidator.family.error ? (<FormHelperText><FormattedMessage id={array4thValidator.family.helperText} /></FormHelperText>) : null}
                      </FormControl>
                    </FormGroup>
                  </GridItem>
                  {Object.values(array8th).map((item, key) => {
                    //console.log(item);
                    if (item.type === "chkBox") {
                      return (
                        <GridItem xs={12} sm={6} md={item.gridWid} lg={item.gridWid}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={item.checked || false}
                                onChange={handleChange8th}
                                name={item.name}
                                color="primary"
                              />
                            }
                            label={<FormattedMessage id={item.label} />}
                            onMouseDown={() => { item.checked || false ? playActive() : playOn(); }}
                          />
                        </GridItem>)
                    } else {
                      return (
                        <GridItem xs={12} sm={item.gridWid} md={item.gridWid} lg={item.gridWid}>
                          <ListItem style={{ marginLeft: "-11px", paddingLeft: "0px" }}>
                            <Checkbox
                              checked={item.checked || false}
                              onChange={handleChange8th}
                              name={item.name}
                              key={key + 'chk'}
                              inputProps={{ "aria-label": "primary checkbox" }}
                              color="primary"
                              onMouseDown={() => { item.checked || false ? playActive() : playOn(); }}
                            />
                            <TextField
                              fullWidth
                              key={key + 'txt'}
                              error={item.error || false}
                              disabled={!item.checked || false}
                              required={item.checked || false}
                              value={array8thTxtObj[item.name].text || ""}
                              label={<FormattedMessage id={item.label} />}
                              name={item.name}
                              autoComplete="off"
                              onChange={handleChangeTxt8th}
                              // inputProps={{
                              //   type2:item.type
                              // }}
                              helperText={item.error ? <FormattedMessage id={item.helperText} /> : null}
                            />
                          </ListItem>
                        </GridItem>)
                    }

                  })}
                </GridContainer>
              </fieldset>


              <div style={{ width: '100%', bottom: !imageURL ? "36px" : "0px", position: "fixed", }}>
                {/* <BorderLinearProgress variant="determinate" value={(numerator / denominator) * 100} /> */}
              </div>
              {/* <Signature setImage={setImage} imageURL={imageURL} setTime={setTime} handleSubmit={handleSubmit} open={open} setOpen={setOpen} Update80th={Update80th} /> */}
              {!imageURL ? (
                <>
                  <div className={classes.submitBottomSpacer} />
                  <div className={classes.fixedSubmitBar}>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      onClick={handleSubmit}
                      className={classes.submitButton}
                    >
                      <FormattedMessage id={"app.Submit"} />
                    </Button>
                  </div>
                </>
              ) : null}


            </MuiPickersUtilsProvider>
          </form>
          {/* {imageURL ?
            (<div id={"signature"} >
              <div style={{ textAlign: "lefts" }} >
                <img
                  src={imageURL}
                  alt="my signature"
                  align="center"
                  style={{
                    // display: "block",
                    margin: "0 auto",
                    borderBottom: "1px solid black",
                    width: "250px",
                    paddingLeft: "30px", //讓簽名更像
                    paddingRight: "30px",//讓簽名更像
                  }}
                />
              </div>
              <div>
                <label>簽名時間：{timestamp}</label>
              </div>
            </div>
            )
            : null
          } */}

        </GridItem>

      </GridContainer>
      {/* <div>
        {imageURL ? <Button variant="outlined" color="primary" onClick={ToPdf} style={{ margin: "0 40px" }}>上傳</Button> : null}
      </div> */}
    </Paper >
  );
})

export default Questionaire80th;

// const MultipleComponet = React.forwardRef((props,ref)=>{


//   return(
//     <div ref={ref}>
//       <Questionaire80th></Questionaire80th>
//       <Questionaire67th></Questionaire67th>
//     </div>
//   )
// })

// const Example = () => {
//   const componentRef = useRef();
//   const handlePrint = useReactToPrint({
//     content: () => componentRef.current,
//   });

//   return (
//     <div>
//       <MultipleComponet ref={componentRef} />
//       <button onClick={handlePrint}>Print this out!</button>
//     </div>
//   );
// };


// export default Example;
